import { GeneratedBuildData } from 'web/data/models'

export const GENERATED_MAIN: GeneratedBuildData = JSON.parse(`{
    "changelog": [
      "- Flourish CD changed to 60s from 90s",
      "- Inner Peace reduces Tranq CD by 30s, was 60s.",
      "- Ultimate Penitence added for Disc priest."
    ],
    "modifiersById": {
      "5a4f7a88-f089-4ba7-888f-412aa94f655a": {
        "eligibleSpecIds": [
          "0c9d68bc-e126-4a07-817a-72c37094e005",
          "2fed59fd-6bdc-4b4e-a7d6-70c70cf8a5aa",
          "34b5a797-05ef-4431-91a0-64cc76a97624"
        ],
        "game_id": 53271,
        "icon_name": "ability_hunter_masterscall",
        "id": "5a4f7a88-f089-4ba7-888f-412aa94f655a",
        "meta": "",
        "name": "Master's Call",
        "shortName": "Call"
      },
      "b6867bde-4ca2-4a8b-9c39-f431e42e0648": {
        "eligibleSpecIds": [
          "d122a0b5-d857-4bc5-a456-c7250f8f6690",
          "da2dc773-9412-4b11-ab2b-7d06e200b9d3"
        ],
        "game_id": 422083,
        "icon_name": "inv_treepet",
        "id": "b6867bde-4ca2-4a8b-9c39-f431e42e0648",
        "link_suffix": "",
        "meta": "",
        "name": "Smoldering Seedling",
        "shortName": "Seed"
      }
    },
    "patchInfo": {
      "buildVersion": "1030_0"
    },
    "specsById": {
      "08853913-0c47-4ca1-aec0-e93206a6ee45": {
        "classId": "122a0a6d-d523-4cc2-a743-f3d42d3e7f02",
        "icon_name": "ability_demonhunter_specdps",
        "id": "08853913-0c47-4ca1-aec0-e93206a6ee45",
        "name": "Havoc",
        "role": "Melee DPS",
        "shortName": "Havoc",
        "spellIds": [
          "21771cdf-a784-4605-bcce-1e5d2ada834f"
        ],
        "talentIds": [
          "5a32b827-1860-434c-915f-d470aac4b1c8"
        ]
      },
      "0c9d68bc-e126-4a07-817a-72c37094e005": {
        "classId": "0a3fc2d5-66d5-42da-abc4-2bfbcf5bc9b3",
        "icon_name": "ability_hunter_camouflage",
        "id": "0c9d68bc-e126-4a07-817a-72c37094e005",
        "name": "Survival",
        "role": "Melee DPS",
        "shortName": "Surv",
        "spellIds": [
          "a3789fef-6a46-4667-ad95-bcaacbb4f292",
          "e7767fd1-822f-4939-963d-44312f996a28"
        ],
        "talentIds": [
          "4d6f3b2a-f84a-43f9-a018-8ec21fb84195",
          "aee09758-fd54-4baa-a99c-26e6bfc53275"
        ]
      },
      "18dad85c-ac2c-4aac-b0f8-e0fc4b8633e6": {
        "classId": "9223f4e8-8669-451e-815a-d53a19416c5a",
        "icon_name": "spell_monk_brewmaster_spec",
        "id": "18dad85c-ac2c-4aac-b0f8-e0fc4b8633e6",
        "name": "Brewmaster",
        "role": "Tank",
        "shortName": "BRM",
        "spellIds": [
          "7522cfd0-3958-443d-a286-7cb05d1212a0"
        ],
        "talentIds": []
      },
      "1b478900-c50e-49f6-b9b1-d2fedfb10c2b": {
        "classId": "532f16f1-1e8b-4aba-af5d-17b292fc05fd",
        "icon_name": "spell_deathknight_unholypresence",
        "id": "1b478900-c50e-49f6-b9b1-d2fedfb10c2b",
        "name": "Unholy",
        "role": "Melee DPS",
        "shortName": "Unholy",
        "spellIds": [
          "feb876f1-8dcd-4a92-9234-577aece679e0"
        ],
        "talentIds": []
      },
      "1df0b300-a31e-4ebc-be57-a909f82bab4b": {
        "classId": "d599cd61-11ae-4a4d-a856-60d1c7f4572d",
        "icon_name": "spell_nature_lightning",
        "id": "1df0b300-a31e-4ebc-be57-a909f82bab4b",
        "name": "Elemental",
        "role": "Ranged DPS",
        "shortName": "Ele",
        "spellIds": [
          "22235b91-f2c7-4767-977c-14b81298a0fc",
          "3b0c6694-b5c0-467c-88db-229019aa9714"
        ],
        "talentIds": [
          "b3b02b26-5e57-4717-9170-2b20da209a25",
          "b5f1880d-fa01-4e01-abfa-90051be029d3"
        ]
      },
      "1fcfbc91-0ad8-4c1d-ab1a-ff9424abc17d": {
        "classId": "0a450e25-065c-4c3c-a881-cea74cf08462",
        "icon_name": "ability_warrior_innerrage",
        "id": "1fcfbc91-0ad8-4c1d-ab1a-ff9424abc17d",
        "name": "Fury",
        "role": "Melee DPS",
        "shortName": "Fury",
        "spellIds": [
          "068b52d9-6405-4b9a-a974-c0fb84d8bb76"
        ],
        "talentIds": []
      },
      "2fed59fd-6bdc-4b4e-a7d6-70c70cf8a5aa": {
        "classId": "0a3fc2d5-66d5-42da-abc4-2bfbcf5bc9b3",
        "icon_name": "ability_hunter_bestialdiscipline",
        "id": "2fed59fd-6bdc-4b4e-a7d6-70c70cf8a5aa",
        "name": "Beast Mastery",
        "role": "Ranged DPS",
        "shortName": "BM",
        "spellIds": [
          "447abc6e-4f45-409b-a600-c37c486fa68f",
          "f2a3eb43-dad6-4f8e-8cd4-9e31e321ccb3"
        ],
        "talentIds": [
          "044e86a9-885e-4180-a808-bb649682236d",
          "28098ed2-33a2-4883-91e5-98e1ce3bed0d"
        ]
      },
      "34735ecf-bf9e-4225-bb6e-ee617b024b70": {
        "classId": "532f16f1-1e8b-4aba-af5d-17b292fc05fd",
        "icon_name": "spell_deathknight_bloodpresence",
        "id": "34735ecf-bf9e-4225-bb6e-ee617b024b70",
        "name": "Blood",
        "role": "Tank",
        "shortName": "Blood",
        "spellIds": [
          "6386b688-0165-484e-bd47-d2cdac170ada"
        ],
        "talentIds": []
      },
      "34b5a797-05ef-4431-91a0-64cc76a97624": {
        "classId": "0a3fc2d5-66d5-42da-abc4-2bfbcf5bc9b3",
        "icon_name": "ability_hunter_focusedaim",
        "id": "34b5a797-05ef-4431-91a0-64cc76a97624",
        "name": "Marksman",
        "role": "Ranged DPS",
        "shortName": "Mark",
        "spellIds": [
          "3e3d7ca0-2d5f-4ac9-96b7-22749392a636",
          "fb58730d-151a-48b8-8100-f47b51e91fe5"
        ],
        "talentIds": [
          "40eddbc9-887e-4be7-a8b9-e270403823ba",
          "e2e5a6fa-907e-4b17-bc51-164330309e88"
        ]
      },
      "3f5cbe75-0a0e-4406-90a7-d46833c9fca2": {
        "classId": "5b6efded-e5dd-4429-adfd-2c6d3893e678",
        "icon_name": "ability_rogue_waylay",
        "id": "3f5cbe75-0a0e-4406-90a7-d46833c9fca2",
        "name": "Outlaw",
        "role": "Melee DPS",
        "shortName": "Outlaw",
        "spellIds": [],
        "talentIds": []
      },
      "48a205f0-5e24-4382-9e0b-3c06cfc1b873": {
        "classId": "fabd40be-24a8-4b80-8445-416b6e77e15f",
        "icon_name": "classicon_evoker_preservation",
        "id": "48a205f0-5e24-4382-9e0b-3c06cfc1b873",
        "name": "Preservation",
        "role": "Healer",
        "shortName": "Pres",
        "spellIds": [
          "0b334074-15b9-4f64-baa5-27442c2d152b",
          "2d020099-cda1-4cdd-96b1-4b61d5e53c62",
          "430d3776-e86a-4f9e-bf53-0cc12ae0f114",
          "45e29715-be0c-4ceb-a9f0-916db8c36ea5",
          "a2da2eeb-159f-4da1-832a-77bddb48c148",
          "d49ffdc7-7c0b-4ca9-8af2-dda0cabdbf10",
          "fc7719be-9707-4b79-be11-e1e6580d046e"
        ],
        "talentIds": [
          "1982bd2c-d922-432a-842a-487e0232ec4a",
          "800d564e-c86d-4bee-ab87-5a946fd60f77",
          "97cbd734-cbb8-44ce-92f3-f24f57f9c278",
          "a4d2f672-c49e-4dfa-a83b-8bb53a8310b8",
          "c42ffd64-26da-4beb-b288-dbe82933f3e9",
          "e4be4ca1-4cb2-4325-aeff-955cca81cec3",
          "eb1aebb0-bda2-40ae-9583-7880106bf32a"
        ]
      },
      "48c27d79-2cc2-4674-bfd0-9a471f6c7ced": {
        "classId": "f3899285-de29-4692-a640-98b5d03579ee",
        "icon_name": "spell_shadow_shadowwordpain",
        "id": "48c27d79-2cc2-4674-bfd0-9a471f6c7ced",
        "name": "Shadow",
        "role": "Ranged DPS",
        "shortName": "Shadow",
        "spellIds": [
          "29f0d1dc-b9c4-46e0-bf62-34f3cf90ff86",
          "77441883-c965-4adf-8ffb-7ec6d0460a1f",
          "ebcc79a1-c952-4129-870d-7b810f00a2f6"
        ],
        "talentIds": [
          "239021f7-5a79-419c-8da7-292588e70edd",
          "360cde43-3b69-4401-8f26-68f5d56f4aeb",
          "7c3dbefe-6e19-495f-8e19-3913fd1bd2b7",
          "986f8c08-5f23-48e4-9af0-f9e974cccb01"
        ]
      },
      "4ac0a1e4-3352-49e9-b455-faa83312526d": {
        "classId": "d056557a-1414-4958-b859-11656dfc0528",
        "icon_name": "spell_holy_auraoflight",
        "id": "4ac0a1e4-3352-49e9-b455-faa83312526d",
        "name": "Retribution",
        "role": "Melee DPS",
        "shortName": "Ret",
        "spellIds": [
          "30acd7aa-b771-45d5-b77b-0deebafaa17e",
          "73488826-37cf-477f-b6c5-930e06fc1f0b",
          "e205cd22-baf6-4791-9c5b-aa9cbd84b98f",
          "eeeff96c-29b3-4f74-98a7-4e3239da8e94"
        ],
        "talentIds": [
          "5c63e9af-48bd-4a08-8738-c71c1a540bcc",
          "7c6fd8c0-30bb-4bc6-9d50-2b969b7571b4",
          "80586d92-41db-40f1-ae5f-a978012ca6fd",
          "98dc455b-cea8-4003-a669-68bf94dbd706"
        ]
      },
      "51daa0f0-df16-4983-ae44-e11b5f9b3edb": {
        "classId": "d599cd61-11ae-4a4d-a856-60d1c7f4572d",
        "icon_name": "spell_nature_magicimmunity",
        "id": "51daa0f0-df16-4983-ae44-e11b5f9b3edb",
        "name": "Restoration",
        "role": "Healer",
        "shortName": "Resto",
        "spellIds": [
          "3a923582-aebe-4734-9313-77623a02bccc",
          "3f3fbc8c-77b9-48fb-ae44-476557f52e60",
          "4b0a01d0-3880-49d9-bfaf-3d57b19ee9a4",
          "6c76c167-7172-4356-9293-068a770aad3e",
          "8303fff4-933f-457d-9119-5a81c23f464b",
          "9a7444f4-84f3-4ff6-8302-571d8814002b",
          "d38204ba-8251-4251-b1d9-0e4b0e16905d"
        ],
        "talentIds": [
          "407c87da-0b1a-4100-853d-7b7de8bc7387",
          "57ef3256-3b78-4c7e-bc3e-8767a590f7dd",
          "5d148a72-569a-4901-a4b1-6b5c05f71f17",
          "7b15b336-3209-4055-893d-8ef670236bca",
          "b04b16b4-c8ac-411e-bbd2-c7e97a1fc66a"
        ]
      },
      "575905ae-cdc7-44c8-946c-861d50111b6d": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "icon_name": "ability_druid_catform",
        "id": "575905ae-cdc7-44c8-946c-861d50111b6d",
        "name": "Feral",
        "role": "Melee DPS",
        "shortName": "Feral",
        "spellIds": [
          "01f637f5-1404-4c9c-8a2a-297252707a82",
          "514c1ffe-de1e-4329-9f7c-c32c3cec5f64",
          "5cc5e8a5-c07b-453c-87f6-75139b564e0f"
        ],
        "talentIds": [
          "a6970508-b6df-4db0-8d96-453da1bbaf70",
          "cf4c2e81-6529-4ddc-8067-81ea5160ebbe",
          "d9c89245-c7cd-4c47-9453-0c3763b1e0f6"
        ]
      },
      "67a45712-192e-4916-ad57-d9a13124fea6": {
        "classId": "f3899285-de29-4692-a640-98b5d03579ee",
        "icon_name": "spell_holy_powerwordshield",
        "id": "67a45712-192e-4916-ad57-d9a13124fea6",
        "name": "Discipline",
        "role": "Healer",
        "shortName": "Disc",
        "spellIds": [
          "1b8f93b0-4912-4290-bd4c-1fbb76dcc570",
          "4365f48f-87f6-488f-aaf1-acabede5dfb8",
          "6b801340-ee10-4763-a252-bf4d1265462a",
          "90e5941b-8b3c-4e6d-bb5b-cab423b22530",
          "bee1d61c-4ec8-40a7-9271-ade5e04c105d",
          "c1f89e9f-b82b-4260-b21b-4e883a47f904",
          "cf7b5dd4-1b50-4b46-b22e-b3657d5b4dfb",
          "dc628570-df9a-4120-a980-c322e7a12418",
          "e5474b0b-d85d-4f21-8f59-a6d32db4ebe5",
          "e904a4d5-d48c-4bfc-bd04-32e503fb41b2"
        ],
        "talentIds": [
          "15632714-d0a2-4b64-91f8-0ebd519d44eb",
          "1c63e505-ed5c-45f8-97d4-634580f32502",
          "305ad67b-e950-4424-93fc-660b112f7b07",
          "8f71aa7f-af2a-4dd2-9f1f-3d54359c0f46",
          "e5e78e16-a4aa-464d-88b2-e5579a580d85",
          "fa4bff3c-7b54-41dc-affb-a8a66f7a7283"
        ]
      },
      "6c233e8c-5bd4-4ece-9fb8-529a1e78759b": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "icon_name": "spell_nature_starfall",
        "id": "6c233e8c-5bd4-4ece-9fb8-529a1e78759b",
        "name": "Balance",
        "role": "Ranged DPS",
        "shortName": "Balance",
        "spellIds": [
          "18af3624-ce9b-4ac4-8671-52648d197386",
          "205c7568-79cf-4927-9539-bd8a2d64b4db",
          "4c36b47f-9c7e-4d70-bab6-784e3054860f"
        ],
        "talentIds": [
          "4f7afe94-0e36-41d8-8560-236fa522beb5",
          "594a40e8-bd2f-4358-8e40-d9daa5580c58",
          "d1e6a9e3-a1ae-4ea1-b71e-c16d941a7750"
        ]
      },
      "72947601-4270-4e1e-b917-25aacaa6d3e0": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "icon_name": "spell_nature_healingtouch",
        "id": "72947601-4270-4e1e-b917-25aacaa6d3e0",
        "name": "Restoration",
        "role": "Healer",
        "shortName": "Resto",
        "spellIds": [
          "1163576b-e119-43fe-b17a-9021e0ebabb4",
          "2b6b27a1-b184-440d-b33d-9378a7eaf6a3",
          "6795689c-037e-4568-957c-35e30eae6e35",
          "6f969267-1c22-4585-9852-45fb2c6b3827",
          "833c2006-4530-441e-b9bb-8df2f71f5e92",
          "cc6474aa-1a23-4064-af59-8fd2fdde5587"
        ],
        "talentIds": [
          "498f753d-cfbc-4d2c-ba71-823753945c2e",
          "4b5a6ee9-25c2-437f-a1b1-00da51e60c56",
          "52016a77-9b0d-4b93-937f-18055955925a",
          "66b049ed-1881-40bb-8279-69b611e0ac77",
          "abeb88c2-7c18-4580-8436-8cc6f0e45a12",
          "d2f7d123-426d-4d97-a25a-d8f7cc661a09"
        ]
      },
      "7f8d7fab-f5cc-4d47-9212-565bab25aeed": {
        "classId": "843ce836-b215-488f-b73b-d08e3904ddca",
        "icon_name": "spell_fire_firebolt02",
        "id": "7f8d7fab-f5cc-4d47-9212-565bab25aeed",
        "name": "Fire",
        "role": "Ranged DPS",
        "shortName": "Fire",
        "spellIds": [
          "69505148-21ae-4115-91d7-b37b47d025f9"
        ],
        "talentIds": [
          "81b9786f-7c9a-4c30-b750-28f97721a7b7"
        ]
      },
      "83b7651d-c296-4a15-9932-b4012144b6ec": {
        "classId": "0a450e25-065c-4c3c-a881-cea74cf08462",
        "icon_name": "ability_warrior_defensivestance",
        "id": "83b7651d-c296-4a15-9932-b4012144b6ec",
        "name": "Protection",
        "role": "Tank",
        "shortName": "Prot",
        "spellIds": [
          "9c525ec0-db53-46ae-b854-c3b3f4a90b97"
        ],
        "talentIds": []
      },
      "88f4a6b5-7766-41c3-b824-fbba531a2c8e": {
        "classId": "9223f4e8-8669-451e-815a-d53a19416c5a",
        "icon_name": "spell_monk_windwalker_spec",
        "id": "88f4a6b5-7766-41c3-b824-fbba531a2c8e",
        "name": "Windwalker",
        "role": "Melee DPS",
        "shortName": "WW",
        "spellIds": [
          "60f9a873-e358-44ad-9946-8b9c8bd5beea"
        ],
        "talentIds": [
          "0eafdd9a-7464-4923-8f2f-0ee4b9ab9a46"
        ]
      },
      "8fceebcc-a93b-4692-81ea-331b2e59d43d": {
        "classId": "d056557a-1414-4958-b859-11656dfc0528",
        "icon_name": "ability_paladin_shieldofthetemplar",
        "id": "8fceebcc-a93b-4692-81ea-331b2e59d43d",
        "name": "Protection",
        "role": "Tank",
        "shortName": "Prot",
        "spellIds": [
          "223ebeb3-a3b1-4934-8088-c64e2333abac",
          "7270f068-2855-493f-af9c-04f1470b8fdf",
          "ac2e2aab-5799-414d-9927-0dc90ccd63fb",
          "b017d61c-8666-45ba-9334-25a84a08c05a",
          "c4b91863-0e64-415f-b7df-a61edb311063"
        ],
        "talentIds": [
          "028b6cfa-7232-41e9-828d-7e59eb5e53b9",
          "29bac947-b181-4ba8-9030-afb7044a0f31",
          "2f3db1c5-2619-41f2-84e1-c94a960532b8",
          "3cc7d649-6033-4419-af00-b4c7451d08c9",
          "8e209307-a17b-46b0-910d-cc373e5f8ad5",
          "ab2034fc-2930-4d09-b300-b18938ad2e1e",
          "c98871c3-83ea-4293-890f-6e143e2a2e87"
        ]
      },
      "a022f6ed-2b4e-4ddf-a7e9-7fb746f5adc2": {
        "classId": "843ce836-b215-488f-b73b-d08e3904ddca",
        "icon_name": "spell_frost_frostbolt02",
        "id": "a022f6ed-2b4e-4ddf-a7e9-7fb746f5adc2",
        "name": "Frost",
        "role": "Ranged DPS",
        "shortName": "Frost",
        "spellIds": [
          "c2aae075-4f7e-48d9-8146-f2dcd408b45e"
        ],
        "talentIds": [
          "eb13e796-1375-43cd-b198-1f1f55d6baef"
        ]
      },
      "ab48ab5c-dfb9-4ce9-9557-8d0ce5129df2": {
        "classId": "843ce836-b215-488f-b73b-d08e3904ddca",
        "icon_name": "spell_holy_magicalsentry",
        "id": "ab48ab5c-dfb9-4ce9-9557-8d0ce5129df2",
        "name": "Arcane",
        "role": "Ranged DPS",
        "shortName": "Arcane",
        "spellIds": [
          "7b7dacff-a0e3-44f7-bc5f-6c0f9ac4421b",
          "940785f5-e48d-42a7-b1a0-2bd29d3f99d0",
          "955b8011-ce1b-49b8-bac4-f6a3cacda5df",
          "cb56d376-f42d-4100-b4ee-b7cb17c5beae"
        ],
        "talentIds": [
          "2a833adb-fb0e-4b54-9f98-af7a6cfc0e83",
          "96558e37-14f0-443f-b8a1-14cb54899111",
          "abc55aba-b958-401e-9ea8-c46fcf6e7563",
          "cadc9039-5b5e-4f91-9abf-c76a7e631a73"
        ]
      },
      "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9": {
        "classId": "d599cd61-11ae-4a4d-a856-60d1c7f4572d",
        "icon_name": "spell_shaman_improvedstormstrike",
        "id": "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9",
        "name": "Enhancement",
        "role": "Melee DPS",
        "shortName": "Enh",
        "spellIds": [
          "50b8ca1b-360b-448a-9424-60fe77dedea5",
          "ed6c4a47-d7ea-4b19-a25a-0d3f60f284ef"
        ],
        "talentIds": [
          "15d965d9-9925-4b64-ae46-a63d97c1f5ed",
          "3b66a3e0-7960-40a3-9e5a-894951833520"
        ]
      },
      "b72fb4f9-413a-4222-8569-b3cb8e5e67f2": {
        "classId": "532f16f1-1e8b-4aba-af5d-17b292fc05fd",
        "icon_name": "spell_deathknight_frostpresence",
        "id": "b72fb4f9-413a-4222-8569-b3cb8e5e67f2",
        "name": "Frost",
        "role": "Melee DPS",
        "shortName": "Frost",
        "spellIds": [
          "9cb0595b-3b66-480b-862c-df40fb7cea1b"
        ],
        "talentIds": []
      },
      "bcaf8201-dac9-48b9-b329-f2d73d7e8a8b": {
        "classId": "1d680db4-2a3f-4805-800d-00ea34d98880",
        "icon_name": "spell_shadow_metamorphosis",
        "id": "bcaf8201-dac9-48b9-b329-f2d73d7e8a8b",
        "name": "Demonology",
        "role": "Ranged DPS",
        "shortName": "Demo",
        "spellIds": [],
        "talentIds": []
      },
      "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "icon_name": "ability_racial_bearform",
        "id": "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f",
        "name": "Guardian",
        "role": "Tank",
        "shortName": "Guard",
        "spellIds": [
          "b897eab4-3a79-4d8d-a05a-8e5afca42681",
          "e4fefe2e-fba9-412a-af1b-1d2a30e5f2a9"
        ],
        "talentIds": [
          "2bc3e4f6-11a9-4225-bc58-98697672c128",
          "894e4c1a-ba49-4a3b-b269-8b3744ea8993"
        ]
      },
      "c719a5bb-cbad-4e7b-841e-bbc7f28f6865": {
        "classId": "1d680db4-2a3f-4805-800d-00ea34d98880",
        "icon_name": "spell_shadow_rainoffire",
        "id": "c719a5bb-cbad-4e7b-841e-bbc7f28f6865",
        "name": "Destruction",
        "role": "Ranged DPS",
        "shortName": "Destro",
        "spellIds": [],
        "talentIds": []
      },
      "c95c2375-57fa-4ae8-9d55-c2e939b82247": {
        "classId": "122a0a6d-d523-4cc2-a743-f3d42d3e7f02",
        "icon_name": "ability_demonhunter_spectank",
        "id": "c95c2375-57fa-4ae8-9d55-c2e939b82247",
        "name": "Vengeance",
        "role": "Tank",
        "shortName": "Veng",
        "spellIds": [
          "a4f552be-7f42-40a9-b7be-f5475119fc0f"
        ],
        "talentIds": [
          "d339058d-622c-4a33-a19e-86f712f8b9ab"
        ]
      },
      "cbfc9a1d-a504-4c56-8887-681e57a87211": {
        "classId": "fabd40be-24a8-4b80-8445-416b6e77e15f",
        "icon_name": "classicon_evoker_devastation",
        "id": "cbfc9a1d-a504-4c56-8887-681e57a87211",
        "name": "Devastation",
        "role": "Ranged DPS",
        "shortName": "Deva",
        "spellIds": [
          "81c6a0e4-88ca-4d58-a078-378a58cd9872",
          "a21c31fa-27af-430e-ad89-99e10a94b757",
          "e848e549-ff36-461e-b171-9a86c6f43d61"
        ],
        "talentIds": [
          "09f94147-cd2c-4760-b6a6-c72119ad16ff",
          "4938f839-6a91-462c-b992-b41e78881fe9",
          "a797ceed-5721-49ab-89cb-cd5ef27c393c"
        ]
      },
      "d122a0b5-d857-4bc5-a456-c7250f8f6690": {
        "classId": "f3899285-de29-4692-a640-98b5d03579ee",
        "icon_name": "spell_holy_guardianspirit",
        "id": "d122a0b5-d857-4bc5-a456-c7250f8f6690",
        "name": "Holy",
        "role": "Healer",
        "shortName": "Holy",
        "spellIds": [
          "1da6673b-364a-45a3-b8fb-b17bab4373ea",
          "2411a7be-6253-4fed-aa14-8c5be8e4f9c8",
          "2c5175b0-8d2f-4448-99a6-401bed1ff33a",
          "46ff006b-94c9-4c8d-a874-ba4809bbf2d1",
          "9c5fd215-e1e7-4428-b6d4-3921ee75b658",
          "c518e083-e2c4-40f3-b22c-13a392604b33",
          "cdcb654f-712c-45b2-8297-74d2b9d793c5",
          "e61379c8-5780-4df8-8a90-83079abcc1e2"
        ],
        "talentIds": [
          "01e447b9-c926-41c4-b00e-69b13791feb2",
          "44a0af8e-62d2-44b6-b9cf-b4ca047d62ca",
          "4dfbac2d-6f87-4391-85b0-5080346a095e",
          "71c5868a-def8-466a-b63d-fc82da933afd",
          "a47c5164-18f6-4906-aeb5-e71f041811e7",
          "db273c6f-f072-4542-9e40-ae7a5fc33544",
          "f5feefda-5464-4fa3-8970-51d652452328"
        ]
      },
      "da2dc773-9412-4b11-ab2b-7d06e200b9d3": {
        "classId": "9223f4e8-8669-451e-815a-d53a19416c5a",
        "icon_name": "spell_monk_mistweaver_spec",
        "id": "da2dc773-9412-4b11-ab2b-7d06e200b9d3",
        "name": "Mistweaver",
        "role": "Healer",
        "shortName": "MW",
        "spellIds": [
          "04677e77-160e-4492-bfd9-4688779d69e7",
          "6a55e942-bebb-439e-9534-f7172dd9f3bd",
          "b505633a-8976-49ca-b95b-7444b8eb1d98",
          "bcb49fff-e6be-43a7-87f0-3924c80f69b1",
          "c2abca06-6a67-4266-b5f3-1c67a6455568",
          "d010caed-ec87-482b-87af-8cc59d03fab3",
          "d74ce276-d46e-4094-b0f3-dc01c9c2aadd"
        ],
        "talentIds": [
          "3523dbe5-540b-41dd-b1cd-7d65ca1401ea",
          "81601bb9-101e-454a-979e-a6ba776489ba",
          "98617053-d678-46a5-aea8-6f8ad998a3d0",
          "a7d8a267-6a18-4292-88a3-e013c519229e",
          "e8f11fe0-06b1-4369-9fed-f13344e8e213"
        ]
      },
      "e1af3b62-ddf5-4369-a528-dab8ab94d366": {
        "classId": "d056557a-1414-4958-b859-11656dfc0528",
        "icon_name": "spell_holy_holybolt",
        "id": "e1af3b62-ddf5-4369-a528-dab8ab94d366",
        "name": "Holy",
        "role": "Healer",
        "shortName": "Holy",
        "spellIds": [
          "1bc7a0e4-44fa-4006-95ff-a90c900478cc",
          "41f8869e-36a9-4b89-8ea5-ceb2d3a5f5de",
          "57c9cbbb-a53a-48ad-99d6-5470ac05dd6a",
          "82ae822d-810a-4ea7-bf5f-37659b5c5732",
          "86733566-6ab6-46ea-ab4a-bab3d2b1084a",
          "a323b4eb-b7b8-4ecf-8927-9fe5b6c2bb85",
          "a6c48753-3e21-44a8-b671-f04f76391590",
          "c0314f42-8e26-4cf1-9ce4-dc1b3d5da1c0",
          "dfe0fd25-b7f7-4c16-b501-4fe23b95d5d3",
          "f4c9ddcb-69c4-4c2a-94f8-89581e08a4c0"
        ],
        "talentIds": [
          "49cde047-4a88-4df9-80a1-4dc0c3953ac4",
          "75ffa906-35ee-46fc-a1a3-846ee2e47899",
          "7d749792-b86e-4a0c-b7af-a22c515c905d",
          "9a5cd364-9619-40f6-b783-1d5135f4e7a3",
          "aa2917be-60cb-40a9-8bb7-c2eda9cada45",
          "b07d824b-dae9-4128-aa17-960113a669d6",
          "b88a8d95-329b-4a47-9001-6a40c7ce44d9",
          "c0b9d905-4faf-449e-8cc5-62d5af706e83",
          "eabc5bf5-c27d-42d3-b6e0-8468e7c1a161",
          "fd48549c-adae-4459-aa15-fa3d529f34df"
        ]
      },
      "e6b1de69-ce2c-467c-ae7a-e1613ba23fb9": {
        "classId": "fabd40be-24a8-4b80-8445-416b6e77e15f",
        "icon_name": "classicon_evoker_augmentation",
        "id": "e6b1de69-ce2c-467c-ae7a-e1613ba23fb9",
        "name": "Augmentation",
        "role": "Ranged DPS",
        "shortName": "Aug",
        "spellIds": [
          "032fe402-a58b-4433-ae30-d2715f8fb699",
          "931c6f1a-02b3-4d0b-88b1-519042430096",
          "c454c95a-df24-46bb-b1ec-db5575a6466c",
          "f372b736-5827-4982-b657-ffcb0cef9deb"
        ],
        "talentIds": [
          "00de5e1c-3258-4141-8c08-4b3726c263b2",
          "7ced931c-d8d4-46bf-85cd-2bc713b2de65",
          "aea41167-617a-4869-9209-57b95a9b7f96",
          "cbe1ec7e-0b9b-43a8-b935-37ca95037a28"
        ]
      },
      "e92b34bc-aa34-4579-a543-2ece2545d981": {
        "classId": "0a450e25-065c-4c3c-a881-cea74cf08462",
        "icon_name": "ability_warrior_savageblow",
        "id": "e92b34bc-aa34-4579-a543-2ece2545d981",
        "name": "Arms",
        "role": "Melee DPS",
        "shortName": "Arms",
        "spellIds": [
          "b91e3291-cc03-4899-88a6-00303782d386"
        ],
        "talentIds": []
      },
      "f7e76d65-219d-47f1-be05-d7464de52a14": {
        "classId": "1d680db4-2a3f-4805-800d-00ea34d98880",
        "icon_name": "spell_shadow_deathcoil",
        "id": "f7e76d65-219d-47f1-be05-d7464de52a14",
        "name": "Affliction",
        "role": "Ranged DPS",
        "shortName": "Affli",
        "spellIds": [],
        "talentIds": []
      },
      "f950baa2-0deb-4250-a225-5232b1e74c2c": {
        "classId": "5b6efded-e5dd-4429-adfd-2c6d3893e678",
        "icon_name": "ability_stealth",
        "id": "f950baa2-0deb-4250-a225-5232b1e74c2c",
        "name": "Subtlety",
        "role": "Melee DPS",
        "shortName": "Sub",
        "spellIds": [],
        "talentIds": []
      },
      "fc46ed9d-3914-469f-a71f-6e4495efcf27": {
        "classId": "5b6efded-e5dd-4429-adfd-2c6d3893e678",
        "icon_name": "ability_rogue_deadlybrew",
        "id": "fc46ed9d-3914-469f-a71f-6e4495efcf27",
        "name": "Assassination",
        "role": "Melee DPS",
        "shortName": "Assa",
        "spellIds": [],
        "talentIds": []
      }
    },
    "spellsById": {
      "01f637f5-1404-4c9c-8a2a-297252707a82": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 106898,
        "icon_name": "spell_druid_stampedingroar_cat",
        "id": "01f637f5-1404-4c9c-8a2a-297252707a82",
        "name": "Stampeding Roar",
        "shortName": "Roar"
      },
      "032fe402-a58b-4433-ae30-d2715f8fb699": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 370665,
        "icon_name": "ability_evoker_flywithme",
        "id": "032fe402-a58b-4433-ae30-d2715f8fb699",
        "link_suffix": "",
        "name": "Rescue",
        "shortName": "Resc",
        "talentId": "aea41167-617a-4869-9209-57b95a9b7f96"
      },
      "04677e77-160e-4492-bfd9-4688779d69e7": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 422083,
        "icon_name": "inv_treepet",
        "id": "04677e77-160e-4492-bfd9-4688779d69e7",
        "link_suffix": "",
        "modifierId": "b6867bde-4ca2-4a8b-9c39-f431e42e0648",
        "name": "Smoldering Seedling",
        "shortName": "Seed"
      },
      "068b52d9-6405-4b9a-a974-c0fb84d8bb76": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 97462,
        "icon_name": "ability_warrior_rallyingcry",
        "id": "068b52d9-6405-4b9a-a974-c0fb84d8bb76",
        "name": "Rallying Cry",
        "shortName": "RC"
      },
      "0b334074-15b9-4f64-baa5-27442c2d152b": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 370960,
        "icon_name": "ability_evoker_green_01",
        "id": "0b334074-15b9-4f64-baa5-27442c2d152b",
        "name": "Emerald Communion",
        "shortName": "Com",
        "talentId": "eb1aebb0-bda2-40ae-9583-7880106bf32a"
      },
      "1163576b-e119-43fe-b17a-9021e0ebabb4": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 102342,
        "icon_name": "spell_druid_ironbark",
        "id": "1163576b-e119-43fe-b17a-9021e0ebabb4",
        "name": "Ironbark",
        "shortName": "IB"
      },
      "18af3624-ce9b-4ac4-8671-52648d197386": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 124974,
        "icon_name": "achievement_zone_feralas",
        "id": "18af3624-ce9b-4ac4-8671-52648d197386",
        "name": "Nature's Vigil",
        "shortName": "Vigil",
        "talentId": "594a40e8-bd2f-4358-8e40-d9daa5580c58"
      },
      "1b8f93b0-4912-4290-bd4c-1fbb76dcc570": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 34433,
        "icon_name": "spell_shadow_shadowfiend",
        "id": "1b8f93b0-4912-4290-bd4c-1fbb76dcc570",
        "name": "Shadowfiend",
        "replacedByTalentId": "15632714-d0a2-4b64-91f8-0ebd519d44eb",
        "shortName": "Fiend"
      },
      "1bc7a0e4-44fa-4006-95ff-a90c900478cc": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 200652,
        "icon_name": "inv_mace_2h_artifactsilverhand_d_01",
        "id": "1bc7a0e4-44fa-4006-95ff-a90c900478cc",
        "name": "Tyr's Deliverance",
        "shortName": "Tyr",
        "talentId": "eabc5bf5-c27d-42d3-b6e0-8468e7c1a161"
      },
      "1da6673b-364a-45a3-b8fb-b17bab4373ea": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 32375,
        "icon_name": "spell_arcane_massdispel",
        "id": "1da6673b-364a-45a3-b8fb-b17bab4373ea",
        "link_suffix": "",
        "name": "Mass Dispel",
        "shortName": "Mass",
        "talentId": "f5feefda-5464-4fa3-8970-51d652452328"
      },
      "205c7568-79cf-4927-9539-bd8a2d64b4db": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 106898,
        "icon_name": "spell_druid_stampedingroar_cat",
        "id": "205c7568-79cf-4927-9539-bd8a2d64b4db",
        "name": "Stampeding Roar",
        "shortName": "Roar"
      },
      "21771cdf-a784-4605-bcce-1e5d2ada834f": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 196718,
        "icon_name": "ability_demonhunter_darkness",
        "id": "21771cdf-a784-4605-bcce-1e5d2ada834f",
        "name": "Darkness",
        "shortName": "Dark"
      },
      "22235b91-f2c7-4767-977c-14b81298a0fc": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 108281,
        "icon_name": "ability_shaman_ancestralguidance",
        "id": "22235b91-f2c7-4767-977c-14b81298a0fc",
        "name": "Ancestral Guidance",
        "shortName": "Guide",
        "talentId": "b3b02b26-5e57-4717-9170-2b20da209a25"
      },
      "223ebeb3-a3b1-4934-8088-c64e2333abac": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 6940,
        "icon_name": "spell_holy_sealofsacrifice",
        "id": "223ebeb3-a3b1-4934-8088-c64e2333abac",
        "name": "Blessing of Sacrifice",
        "shortName": "Sac",
        "talentId": "3cc7d649-6033-4419-af00-b4c7451d08c9"
      },
      "2411a7be-6253-4fed-aa14-8c5be8e4f9c8": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 10060,
        "icon_name": "spell_holy_powerinfusion",
        "id": "2411a7be-6253-4fed-aa14-8c5be8e4f9c8",
        "link_suffix": "",
        "name": "Power Infusion",
        "shortName": "PI",
        "talentId": "4dfbac2d-6f87-4391-85b0-5080346a095e"
      },
      "29f0d1dc-b9c4-46e0-bf62-34f3cf90ff86": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 15286,
        "icon_name": "spell_shadow_unsummonbuilding",
        "id": "29f0d1dc-b9c4-46e0-bf62-34f3cf90ff86",
        "name": "Vampiric Embrace",
        "shortName": "VE"
      },
      "2b6b27a1-b184-440d-b33d-9378a7eaf6a3": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 197721,
        "icon_name": "spell_druid_wildburst",
        "id": "2b6b27a1-b184-440d-b33d-9378a7eaf6a3",
        "name": "Flourish",
        "shortName": "Flou"
      },
      "2c5175b0-8d2f-4448-99a6-401bed1ff33a": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 73325,
        "icon_name": "priest_spell_leapoffaith_a",
        "id": "2c5175b0-8d2f-4448-99a6-401bed1ff33a",
        "link_suffix": "",
        "name": "Leap of Faith",
        "shortName": "Leap",
        "talentId": "01e447b9-c926-41c4-b00e-69b13791feb2"
      },
      "2d020099-cda1-4cdd-96b1-4b61d5e53c62": {
        "affectedByModifierIds": [],
        "cooldown": 240,
        "game_id": 363534,
        "icon_name": "ability_evoker_rewind",
        "id": "2d020099-cda1-4cdd-96b1-4b61d5e53c62",
        "name": "Rewind",
        "shortName": "Rew"
      },
      "30acd7aa-b771-45d5-b77b-0deebafaa17e": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 1022,
        "icon_name": "spell_holy_sealofprotection",
        "id": "30acd7aa-b771-45d5-b77b-0deebafaa17e",
        "name": "Blessing of Protection",
        "shortName": "BoP"
      },
      "3a923582-aebe-4734-9313-77623a02bccc": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 192077,
        "icon_name": "ability_shaman_windwalktotem",
        "id": "3a923582-aebe-4734-9313-77623a02bccc",
        "name": "Wind Rush Totem",
        "shortName": "WRT",
        "talentId": "5d148a72-569a-4901-a4b1-6b5c05f71f17"
      },
      "3b0c6694-b5c0-467c-88db-229019aa9714": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 192077,
        "icon_name": "ability_shaman_windwalktotem",
        "id": "3b0c6694-b5c0-467c-88db-229019aa9714",
        "name": "Wind Rush Totem",
        "shortName": "WRT",
        "talentId": "b5f1880d-fa01-4e01-abfa-90051be029d3"
      },
      "3e3d7ca0-2d5f-4ac9-96b7-22749392a636": {
        "affectedByModifierIds": [],
        "cooldown": 45,
        "game_id": 53271,
        "icon_name": "ability_hunter_masterscall",
        "id": "3e3d7ca0-2d5f-4ac9-96b7-22749392a636",
        "modifierId": "5a4f7a88-f089-4ba7-888f-412aa94f655a",
        "name": "Master's Call",
        "shortName": "Call"
      },
      "3f3fbc8c-77b9-48fb-ae44-476557f52e60": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 98008,
        "icon_name": "spell_shaman_spiritlink",
        "id": "3f3fbc8c-77b9-48fb-ae44-476557f52e60",
        "name": "Spirit Link Totem",
        "shortName": "SLT"
      },
      "41f8869e-36a9-4b89-8ea5-ceb2d3a5f5de": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 375576,
        "icon_name": "ability_bastion_paladin",
        "id": "41f8869e-36a9-4b89-8ea5-ceb2d3a5f5de",
        "name": "Divine Toll",
        "shortName": "Toll",
        "talentId": "fd48549c-adae-4459-aa15-fa3d529f34df"
      },
      "430d3776-e86a-4f9e-bf53-0cc12ae0f114": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 374227,
        "icon_name": "ability_evoker_hoverblack",
        "id": "430d3776-e86a-4f9e-bf53-0cc12ae0f114",
        "name": "Zephyr",
        "shortName": "Zeph",
        "talentId": "e4be4ca1-4cb2-4325-aeff-955cca81cec3"
      },
      "4365f48f-87f6-488f-aaf1-acabede5dfb8": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 246287,
        "icon_name": "spell_holy_divineillumination",
        "id": "4365f48f-87f6-488f-aaf1-acabede5dfb8",
        "name": "Evang",
        "shortName": "Evang"
      },
      "447abc6e-4f45-409b-a600-c37c486fa68f": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 186265,
        "icon_name": "ability_hunter_pet_turtle",
        "id": "447abc6e-4f45-409b-a600-c37c486fa68f",
        "name": "Aspect of the Turtle",
        "shortName": "Turtle"
      },
      "45e29715-be0c-4ceb-a9f0-916db8c36ea5": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 359816,
        "icon_name": "ability_evoker_dreamflight",
        "id": "45e29715-be0c-4ceb-a9f0-916db8c36ea5",
        "name": "Dream Flight",
        "shortName": "Dream",
        "talentId": "1982bd2c-d922-432a-842a-487e0232ec4a"
      },
      "46ff006b-94c9-4c8d-a874-ba4809bbf2d1": {
        "affectedByModifierIds": [],
        "cooldown": 720,
        "game_id": 265202,
        "icon_name": "ability_priest_archangel",
        "id": "46ff006b-94c9-4c8d-a874-ba4809bbf2d1",
        "name": "Holy Word: Salvation",
        "shortName": "Salv",
        "talentId": "a47c5164-18f6-4906-aeb5-e71f041811e7"
      },
      "4b0a01d0-3880-49d9-bfaf-3d57b19ee9a4": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 207399,
        "icon_name": "spell_nature_reincarnation",
        "id": "4b0a01d0-3880-49d9-bfaf-3d57b19ee9a4",
        "name": "Ancestral Protection Totem",
        "shortName": "APT",
        "talentId": "57ef3256-3b78-4c7e-bc3e-8767a590f7dd"
      },
      "4c36b47f-9c7e-4d70-bab6-784e3054860f": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 29166,
        "icon_name": "spell_nature_lightning",
        "id": "4c36b47f-9c7e-4d70-bab6-784e3054860f",
        "link_suffix": "",
        "name": "Innervate",
        "shortName": "Inn",
        "talentId": "4f7afe94-0e36-41d8-8560-236fa522beb5"
      },
      "50b8ca1b-360b-448a-9424-60fe77dedea5": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 108281,
        "icon_name": "ability_shaman_ancestralguidance",
        "id": "50b8ca1b-360b-448a-9424-60fe77dedea5",
        "name": "Ancestral Guidance",
        "shortName": "Guide",
        "talentId": "15d965d9-9925-4b64-ae46-a63d97c1f5ed"
      },
      "514c1ffe-de1e-4329-9f7c-c32c3cec5f64": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 124974,
        "icon_name": "achievement_zone_feralas",
        "id": "514c1ffe-de1e-4329-9f7c-c32c3cec5f64",
        "name": "Nature's Vigil",
        "shortName": "Vigil",
        "talentId": "cf4c2e81-6529-4ddc-8067-81ea5160ebbe"
      },
      "57c9cbbb-a53a-48ad-99d6-5470ac05dd6a": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 642,
        "icon_name": "spell_holy_divineshield",
        "id": "57c9cbbb-a53a-48ad-99d6-5470ac05dd6a",
        "name": "Divine Shield",
        "shortName": "Div"
      },
      "5cc5e8a5-c07b-453c-87f6-75139b564e0f": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 29166,
        "icon_name": "spell_nature_lightning",
        "id": "5cc5e8a5-c07b-453c-87f6-75139b564e0f",
        "link_suffix": "",
        "name": "Innervate",
        "shortName": "Inn",
        "talentId": "a6970508-b6df-4db0-8d96-453da1bbaf70"
      },
      "60f9a873-e358-44ad-9946-8b9c8bd5beea": {
        "affectedByModifierIds": [],
        "cooldown": 30,
        "game_id": 116841,
        "icon_name": "ability_monk_tigerslust",
        "id": "60f9a873-e358-44ad-9946-8b9c8bd5beea",
        "name": "Tiger's Lust",
        "shortName": "Lust",
        "talentId": "0eafdd9a-7464-4923-8f2f-0ee4b9ab9a46"
      },
      "6386b688-0165-484e-bd47-d2cdac170ada": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 51052,
        "icon_name": "spell_deathknight_antimagiczone",
        "id": "6386b688-0165-484e-bd47-d2cdac170ada",
        "name": "Anti-Magic Zone",
        "shortName": "AMZ"
      },
      "6795689c-037e-4568-957c-35e30eae6e35": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 740,
        "icon_name": "spell_nature_tranquility",
        "id": "6795689c-037e-4568-957c-35e30eae6e35",
        "name": "Tranquility",
        "shortName": "Tranq"
      },
      "69505148-21ae-4115-91d7-b37b47d025f9": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 414660,
        "icon_name": "ability_racial_magicalresistance",
        "id": "69505148-21ae-4115-91d7-b37b47d025f9",
        "name": "Mass Barrier",
        "shortName": "Barrier",
        "talentId": "81b9786f-7c9a-4c30-b750-28f97721a7b7"
      },
      "6a55e942-bebb-439e-9534-f7172dd9f3bd": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 322118,
        "icon_name": "ability_monk_dragonkick",
        "id": "6a55e942-bebb-439e-9534-f7172dd9f3bd",
        "name": "Invoke Yu'lon, the Jade Serpent",
        "shortName": "Yu"
      },
      "6b801340-ee10-4763-a252-bf4d1265462a": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 62618,
        "icon_name": "spell_holy_powerwordbarrier",
        "id": "6b801340-ee10-4763-a252-bf4d1265462a",
        "name": "Power Word: Barrier",
        "shortName": "PW:B"
      },
      "6c76c167-7172-4356-9293-068a770aad3e": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 108280,
        "icon_name": "ability_shaman_healingtide",
        "id": "6c76c167-7172-4356-9293-068a770aad3e",
        "name": "Healing Tide Totem",
        "shortName": "HTT"
      },
      "6f969267-1c22-4585-9852-45fb2c6b3827": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 106898,
        "icon_name": "spell_druid_stampedingroar_cat",
        "id": "6f969267-1c22-4585-9852-45fb2c6b3827",
        "name": "Stampeding Roar",
        "shortName": "Roar"
      },
      "7270f068-2855-493f-af9c-04f1470b8fdf": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 642,
        "icon_name": "spell_holy_divineshield",
        "id": "7270f068-2855-493f-af9c-04f1470b8fdf",
        "name": "Divine Shield",
        "shortName": "Div"
      },
      "73488826-37cf-477f-b6c5-930e06fc1f0b": {
        "affectedByModifierIds": [],
        "cooldown": 25,
        "game_id": 1044,
        "icon_name": "spell_holy_sealofvalor",
        "id": "73488826-37cf-477f-b6c5-930e06fc1f0b",
        "name": "Blessing of Freedom",
        "shortName": "Free"
      },
      "7522cfd0-3958-443d-a286-7cb05d1212a0": {
        "affectedByModifierIds": [],
        "cooldown": 30,
        "game_id": 116841,
        "icon_name": "ability_monk_tigerslust",
        "id": "7522cfd0-3958-443d-a286-7cb05d1212a0",
        "name": "Tiger's Lust",
        "shortName": "Lust"
      },
      "77441883-c965-4adf-8ffb-7ec6d0460a1f": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 73325,
        "icon_name": "priest_spell_leapoffaith_a",
        "id": "77441883-c965-4adf-8ffb-7ec6d0460a1f",
        "link_suffix": "",
        "name": "Leap of Faith",
        "shortName": "Leap",
        "talentId": "360cde43-3b69-4401-8f26-68f5d56f4aeb"
      },
      "7b7dacff-a0e3-44f7-bc5f-6c0f9ac4421b": {
        "affectedByModifierIds": [],
        "cooldown": 1000,
        "game_id": 6262,
        "icon_name": "warlock_-healthstone",
        "id": "7b7dacff-a0e3-44f7-bc5f-6c0f9ac4421b",
        "name": "Healthstone",
        "shortName": "HS",
        "talentId": "2a833adb-fb0e-4b54-9f98-af7a6cfc0e83"
      },
      "81c6a0e4-88ca-4d58-a078-378a58cd9872": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 374968,
        "icon_name": "ability_evoker_timespiral",
        "id": "81c6a0e4-88ca-4d58-a078-378a58cd9872",
        "name": "Time Spiral",
        "shortName": "Spiral",
        "talentId": "a797ceed-5721-49ab-89cb-cd5ef27c393c"
      },
      "82ae822d-810a-4ea7-bf5f-37659b5c5732": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 105809,
        "icon_name": "ability_paladin_holyavenger",
        "id": "82ae822d-810a-4ea7-bf5f-37659b5c5732",
        "name": "Holy Avenger",
        "shortName": "HA",
        "talentId": "75ffa906-35ee-46fc-a1a3-846ee2e47899"
      },
      "8303fff4-933f-457d-9119-5a81c23f464b": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 114052,
        "icon_name": "spell_fire_elementaldevastation",
        "id": "8303fff4-933f-457d-9119-5a81c23f464b",
        "name": "Ascendance",
        "shortName": "Asc",
        "talentId": "407c87da-0b1a-4100-853d-7b7de8bc7387"
      },
      "833c2006-4530-441e-b9bb-8df2f71f5e92": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 33891,
        "icon_name": "ability_druid_improvedtreeform",
        "id": "833c2006-4530-441e-b9bb-8df2f71f5e92",
        "name": "Incarnation: Tree of Life",
        "shortName": "Tree",
        "talentId": "498f753d-cfbc-4d2c-ba71-823753945c2e"
      },
      "86733566-6ab6-46ea-ab4a-bab3d2b1084a": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 1022,
        "icon_name": "spell_holy_sealofprotection",
        "id": "86733566-6ab6-46ea-ab4a-bab3d2b1084a",
        "name": "Blessing of Protection",
        "shortName": "BoP",
        "talentId": "49cde047-4a88-4df9-80a1-4dc0c3953ac4"
      },
      "90e5941b-8b3c-4e6d-bb5b-cab423b22530": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 73325,
        "icon_name": "priest_spell_leapoffaith_a",
        "id": "90e5941b-8b3c-4e6d-bb5b-cab423b22530",
        "link_suffix": "",
        "name": "Leap of Faith",
        "shortName": "Leap",
        "talentId": "e5e78e16-a4aa-464d-88b2-e5579a580d85"
      },
      "931c6f1a-02b3-4d0b-88b1-519042430096": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 406732,
        "icon_name": "ability_evoker_stretchtime",
        "id": "931c6f1a-02b3-4d0b-88b1-519042430096",
        "name": "Spatial Paradox",
        "shortName": "Para",
        "talentId": "00de5e1c-3258-4141-8c08-4b3726c263b2"
      },
      "940785f5-e48d-42a7-b1a0-2bd29d3f99d0": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 414660,
        "icon_name": "ability_racial_magicalresistance",
        "id": "940785f5-e48d-42a7-b1a0-2bd29d3f99d0",
        "name": "Mass Barrier",
        "shortName": "Barrier",
        "talentId": "96558e37-14f0-443f-b8a1-14cb54899111"
      },
      "955b8011-ce1b-49b8-bac4-f6a3cacda5df": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 370511,
        "icon_name": "inv_potion_49",
        "id": "955b8011-ce1b-49b8-bac4-f6a3cacda5df",
        "name": "HP Pot",
        "shortName": "Pot",
        "talentId": "cadc9039-5b5e-4f91-9abf-c76a7e631a73"
      },
      "9a7444f4-84f3-4ff6-8302-571d8814002b": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 108281,
        "icon_name": "ability_shaman_ancestralguidance",
        "id": "9a7444f4-84f3-4ff6-8302-571d8814002b",
        "name": "Ancestral Guidance",
        "shortName": "Guide",
        "talentId": "7b15b336-3209-4055-893d-8ef670236bca"
      },
      "9c525ec0-db53-46ae-b854-c3b3f4a90b97": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 97462,
        "icon_name": "ability_warrior_rallyingcry",
        "id": "9c525ec0-db53-46ae-b854-c3b3f4a90b97",
        "name": "Rallying Cry",
        "shortName": "RC"
      },
      "9c5fd215-e1e7-4428-b6d4-3921ee75b658": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 64843,
        "icon_name": "spell_holy_divinehymn",
        "id": "9c5fd215-e1e7-4428-b6d4-3921ee75b658",
        "name": "Divine Hymn",
        "shortName": "Hymn"
      },
      "9cb0595b-3b66-480b-862c-df40fb7cea1b": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 51052,
        "icon_name": "spell_deathknight_antimagiczone",
        "id": "9cb0595b-3b66-480b-862c-df40fb7cea1b",
        "name": "Anti-Magic Zone",
        "shortName": "AMZ"
      },
      "a21c31fa-27af-430e-ad89-99e10a94b757": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 374227,
        "icon_name": "ability_evoker_hoverblack",
        "id": "a21c31fa-27af-430e-ad89-99e10a94b757",
        "name": "Zephyr",
        "shortName": "Zeph",
        "talentId": "4938f839-6a91-462c-b992-b41e78881fe9"
      },
      "a2da2eeb-159f-4da1-832a-77bddb48c148": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 374968,
        "icon_name": "ability_evoker_timespiral",
        "id": "a2da2eeb-159f-4da1-832a-77bddb48c148",
        "name": "Time Spiral",
        "shortName": "Spiral",
        "talentId": "c42ffd64-26da-4beb-b288-dbe82933f3e9"
      },
      "a323b4eb-b7b8-4ecf-8927-9fe5b6c2bb85": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 31884,
        "icon_name": "spell_holy_avenginewrath",
        "id": "a323b4eb-b7b8-4ecf-8927-9fe5b6c2bb85",
        "name": "Avenging Wrath",
        "shortName": "Wings"
      },
      "a3789fef-6a46-4667-ad95-bcaacbb4f292": {
        "affectedByModifierIds": [],
        "cooldown": 45,
        "game_id": 53271,
        "icon_name": "ability_hunter_masterscall",
        "id": "a3789fef-6a46-4667-ad95-bcaacbb4f292",
        "modifierId": "5a4f7a88-f089-4ba7-888f-412aa94f655a",
        "name": "Master's Call",
        "shortName": "Call"
      },
      "a4f552be-7f42-40a9-b7be-f5475119fc0f": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 196718,
        "icon_name": "ability_demonhunter_darkness",
        "id": "a4f552be-7f42-40a9-b7be-f5475119fc0f",
        "name": "Darkness",
        "shortName": "Dark"
      },
      "a6c48753-3e21-44a8-b671-f04f76391590": {
        "affectedByModifierIds": [],
        "cooldown": 45,
        "game_id": 216331,
        "icon_name": "ability_paladin_veneration",
        "id": "a6c48753-3e21-44a8-b671-f04f76391590",
        "name": "Avenging Crusader",
        "shortName": "Crusa",
        "talentId": "aa2917be-60cb-40a9-8bb7-c2eda9cada45"
      },
      "ac2e2aab-5799-414d-9927-0dc90ccd63fb": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 1022,
        "icon_name": "spell_holy_sealofprotection",
        "id": "ac2e2aab-5799-414d-9927-0dc90ccd63fb",
        "name": "Blessing of Protection",
        "shortName": "BoP"
      },
      "b017d61c-8666-45ba-9334-25a84a08c05a": {
        "affectedByModifierIds": [],
        "cooldown": 25,
        "game_id": 1044,
        "icon_name": "spell_holy_sealofvalor",
        "id": "b017d61c-8666-45ba-9334-25a84a08c05a",
        "name": "Blessing of Freedom",
        "shortName": "Free",
        "talentId": "028b6cfa-7232-41e9-828d-7e59eb5e53b9"
      },
      "b505633a-8976-49ca-b95b-7444b8eb1d98": {
        "affectedByModifierIds": [],
        "cooldown": 80,
        "game_id": 399491,
        "icon_name": "inv_staff_2h_artifactshaohao_d_01",
        "id": "b505633a-8976-49ca-b95b-7444b8eb1d98",
        "link_suffix": "",
        "name": "Sheilun's Gift",
        "shortName": "Gift",
        "talentId": "98617053-d678-46a5-aea8-6f8ad998a3d0"
      },
      "b897eab4-3a79-4d8d-a05a-8e5afca42681": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 29166,
        "icon_name": "spell_nature_lightning",
        "id": "b897eab4-3a79-4d8d-a05a-8e5afca42681",
        "link_suffix": "",
        "name": "Innervate",
        "shortName": "Inn",
        "talentId": "2bc3e4f6-11a9-4225-bc58-98697672c128"
      },
      "b91e3291-cc03-4899-88a6-00303782d386": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 97462,
        "icon_name": "ability_warrior_rallyingcry",
        "id": "b91e3291-cc03-4899-88a6-00303782d386",
        "name": "Rallying Cry",
        "shortName": "RC"
      },
      "bcb49fff-e6be-43a7-87f0-3924c80f69b1": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 115310,
        "icon_name": "spell_monk_revival",
        "id": "bcb49fff-e6be-43a7-87f0-3924c80f69b1",
        "name": "Revival",
        "shortName": "Rev"
      },
      "bee1d61c-4ec8-40a7-9271-ade5e04c105d": {
        "affectedByModifierIds": [],
        "cooldown": 240,
        "game_id": 421453,
        "icon_name": "ability_priest_ascendance",
        "id": "bee1d61c-4ec8-40a7-9271-ade5e04c105d",
        "name": "Ultimate Penitence",
        "shortName": "Penti",
        "talentId": "8f71aa7f-af2a-4dd2-9f1f-3d54359c0f46"
      },
      "c0314f42-8e26-4cf1-9ce4-dc1b3d5da1c0": {
        "affectedByModifierIds": [],
        "cooldown": 25,
        "game_id": 1044,
        "icon_name": "spell_holy_sealofvalor",
        "id": "c0314f42-8e26-4cf1-9ce4-dc1b3d5da1c0",
        "name": "Blessing of Freedom",
        "shortName": "Free"
      },
      "c1f89e9f-b82b-4260-b21b-4e883a47f904": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 123040,
        "icon_name": "spell_shadow_soulleech_3",
        "id": "c1f89e9f-b82b-4260-b21b-4e883a47f904",
        "name": "Mindbender",
        "shortName": "Bender",
        "talentId": "15632714-d0a2-4b64-91f8-0ebd519d44eb"
      },
      "c2aae075-4f7e-48d9-8146-f2dcd408b45e": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 414660,
        "icon_name": "ability_racial_magicalresistance",
        "id": "c2aae075-4f7e-48d9-8146-f2dcd408b45e",
        "name": "Mass Barrier",
        "shortName": "Barrier",
        "talentId": "eb13e796-1375-43cd-b198-1f1f55d6baef"
      },
      "c2abca06-6a67-4266-b5f3-1c67a6455568": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 116849,
        "icon_name": "ability_monk_chicocoon",
        "id": "c2abca06-6a67-4266-b5f3-1c67a6455568",
        "name": "Life Cocoon",
        "shortName": "Coco"
      },
      "c454c95a-df24-46bb-b1ec-db5575a6466c": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 374227,
        "icon_name": "ability_evoker_hoverblack",
        "id": "c454c95a-df24-46bb-b1ec-db5575a6466c",
        "name": "Zephyr",
        "shortName": "Zeph",
        "talentId": "cbe1ec7e-0b9b-43a8-b935-37ca95037a28"
      },
      "c4b91863-0e64-415f-b7df-a61edb311063": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 204018,
        "icon_name": "spell_holy_blessingofprotection",
        "id": "c4b91863-0e64-415f-b7df-a61edb311063",
        "name": "Blessing of Spellwarding",
        "shortName": "Ward"
      },
      "c518e083-e2c4-40f3-b22c-13a392604b33": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 422083,
        "icon_name": "inv_treepet",
        "id": "c518e083-e2c4-40f3-b22c-13a392604b33",
        "link_suffix": "",
        "modifierId": "b6867bde-4ca2-4a8b-9c39-f431e42e0648",
        "name": "Smoldering Seedling",
        "shortName": "Seed"
      },
      "cb56d376-f42d-4100-b4ee-b7cb17c5beae": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 373905,
        "icon_name": "ability_vehicle_shellshieldgenerator_green",
        "id": "cb56d376-f42d-4100-b4ee-b7cb17c5beae",
        "name": "Personal 2min",
        "shortName": "Pers",
        "talentId": "abc55aba-b958-401e-9ea8-c46fcf6e7563"
      },
      "cc6474aa-1a23-4064-af59-8fd2fdde5587": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 391528,
        "icon_name": "ability_ardenweald_druid",
        "id": "cc6474aa-1a23-4064-af59-8fd2fdde5587",
        "name": "Convoke the Spirits",
        "shortName": "Con",
        "talentId": "66b049ed-1881-40bb-8279-69b611e0ac77"
      },
      "cdcb654f-712c-45b2-8297-74d2b9d793c5": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 47788,
        "icon_name": "spell_holy_guardianspirit",
        "id": "cdcb654f-712c-45b2-8297-74d2b9d793c5",
        "link_suffix": "",
        "name": "Guardian Spirit",
        "shortName": "GS",
        "talentId": "71c5868a-def8-466a-b63d-fc82da933afd"
      },
      "cf7b5dd4-1b50-4b46-b22e-b3657d5b4dfb": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 33206,
        "icon_name": "spell_holy_painsupression",
        "id": "cf7b5dd4-1b50-4b46-b22e-b3657d5b4dfb",
        "name": "Pain Suppression",
        "shortName": "PS"
      },
      "d010caed-ec87-482b-87af-8cc59d03fab3": {
        "affectedByModifierIds": [],
        "cooldown": 30,
        "game_id": 116841,
        "icon_name": "ability_monk_tigerslust",
        "id": "d010caed-ec87-482b-87af-8cc59d03fab3",
        "name": "Tiger's Lust",
        "shortName": "Lust",
        "talentId": "81601bb9-101e-454a-979e-a6ba776489ba"
      },
      "d38204ba-8251-4251-b1d9-0e4b0e16905d": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 16191,
        "icon_name": "ability_shaman_manatidetotem",
        "id": "d38204ba-8251-4251-b1d9-0e4b0e16905d",
        "link_suffix": "",
        "name": "Mana Tide Totem",
        "shortName": "MTT",
        "talentId": "b04b16b4-c8ac-411e-bbd2-c7e97a1fc66a"
      },
      "d49ffdc7-7c0b-4ca9-8af2-dda0cabdbf10": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 370665,
        "icon_name": "ability_evoker_flywithme",
        "id": "d49ffdc7-7c0b-4ca9-8af2-dda0cabdbf10",
        "link_suffix": "",
        "name": "Rescue",
        "shortName": "Resc",
        "talentId": "97cbd734-cbb8-44ce-92f3-f24f57f9c278"
      },
      "d74ce276-d46e-4094-b0f3-dc01c9c2aadd": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 325197,
        "icon_name": "inv_pet_cranegod",
        "id": "d74ce276-d46e-4094-b0f3-dc01c9c2aadd",
        "name": "Invoke Chi-Ji, the Red Crane",
        "shortName": "Chi",
        "talentId": "3523dbe5-540b-41dd-b1cd-7d65ca1401ea"
      },
      "dc628570-df9a-4120-a980-c322e7a12418": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 47536,
        "icon_name": "spell_holy_rapture",
        "id": "dc628570-df9a-4120-a980-c322e7a12418",
        "name": "Rapt",
        "shortName": "Rapt"
      },
      "dfe0fd25-b7f7-4c16-b501-4fe23b95d5d3": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 6940,
        "icon_name": "spell_holy_sealofsacrifice",
        "id": "dfe0fd25-b7f7-4c16-b501-4fe23b95d5d3",
        "name": "Blessing of Sacrifice",
        "shortName": "Sac"
      },
      "e205cd22-baf6-4791-9c5b-aa9cbd84b98f": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 6940,
        "icon_name": "spell_holy_sealofsacrifice",
        "id": "e205cd22-baf6-4791-9c5b-aa9cbd84b98f",
        "name": "Blessing of Sacrifice",
        "shortName": "Sac",
        "talentId": "7c6fd8c0-30bb-4bc6-9d50-2b969b7571b4"
      },
      "e4fefe2e-fba9-412a-af1b-1d2a30e5f2a9": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 106898,
        "icon_name": "spell_druid_stampedingroar_cat",
        "id": "e4fefe2e-fba9-412a-af1b-1d2a30e5f2a9",
        "name": "Stampeding Roar",
        "shortName": "Roar"
      },
      "e5474b0b-d85d-4f21-8f59-a6d32db4ebe5": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 32375,
        "icon_name": "spell_arcane_massdispel",
        "id": "e5474b0b-d85d-4f21-8f59-a6d32db4ebe5",
        "link_suffix": "",
        "name": "Mass Dispel",
        "shortName": "Mass",
        "talentId": "fa4bff3c-7b54-41dc-affb-a8a66f7a7283"
      },
      "e61379c8-5780-4df8-8a90-83079abcc1e2": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 64901,
        "icon_name": "spell_holy_symbolofhope",
        "id": "e61379c8-5780-4df8-8a90-83079abcc1e2",
        "name": "Symbol of Hope",
        "shortName": "Hope"
      },
      "e7767fd1-822f-4939-963d-44312f996a28": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 186265,
        "icon_name": "ability_hunter_pet_turtle",
        "id": "e7767fd1-822f-4939-963d-44312f996a28",
        "name": "Aspect of the Turtle",
        "shortName": "Turtle"
      },
      "e848e549-ff36-461e-b171-9a86c6f43d61": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 370665,
        "icon_name": "ability_evoker_flywithme",
        "id": "e848e549-ff36-461e-b171-9a86c6f43d61",
        "link_suffix": "",
        "name": "Rescue",
        "shortName": "Resc",
        "talentId": "09f94147-cd2c-4760-b6a6-c72119ad16ff"
      },
      "e904a4d5-d48c-4bfc-bd04-32e503fb41b2": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 10060,
        "icon_name": "spell_holy_powerinfusion",
        "id": "e904a4d5-d48c-4bfc-bd04-32e503fb41b2",
        "link_suffix": "",
        "name": "Power Infusion",
        "shortName": "PI",
        "talentId": "1c63e505-ed5c-45f8-97d4-634580f32502"
      },
      "ebcc79a1-c952-4129-870d-7b810f00a2f6": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 32375,
        "icon_name": "spell_arcane_massdispel",
        "id": "ebcc79a1-c952-4129-870d-7b810f00a2f6",
        "link_suffix": "",
        "name": "Mass Dispel",
        "shortName": "Mass",
        "talentId": "986f8c08-5f23-48e4-9af0-f9e974cccb01"
      },
      "ed6c4a47-d7ea-4b19-a25a-0d3f60f284ef": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 192077,
        "icon_name": "ability_shaman_windwalktotem",
        "id": "ed6c4a47-d7ea-4b19-a25a-0d3f60f284ef",
        "name": "Wind Rush Totem",
        "shortName": "WRT",
        "talentId": "3b66a3e0-7960-40a3-9e5a-894951833520"
      },
      "eeeff96c-29b3-4f74-98a7-4e3239da8e94": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 642,
        "icon_name": "spell_holy_divineshield",
        "id": "eeeff96c-29b3-4f74-98a7-4e3239da8e94",
        "name": "Divine Shield",
        "shortName": "Div"
      },
      "f2a3eb43-dad6-4f8e-8cd4-9e31e321ccb3": {
        "affectedByModifierIds": [],
        "cooldown": 45,
        "game_id": 53271,
        "icon_name": "ability_hunter_masterscall",
        "id": "f2a3eb43-dad6-4f8e-8cd4-9e31e321ccb3",
        "modifierId": "5a4f7a88-f089-4ba7-888f-412aa94f655a",
        "name": "Master's Call",
        "shortName": "Call"
      },
      "f372b736-5827-4982-b657-ffcb0cef9deb": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 374968,
        "icon_name": "ability_evoker_timespiral",
        "id": "f372b736-5827-4982-b657-ffcb0cef9deb",
        "name": "Time Spiral",
        "shortName": "Spiral",
        "talentId": "7ced931c-d8d4-46bf-85cd-2bc713b2de65"
      },
      "f4c9ddcb-69c4-4c2a-94f8-89581e08a4c0": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 31821,
        "icon_name": "spell_holy_auramastery",
        "id": "f4c9ddcb-69c4-4c2a-94f8-89581e08a4c0",
        "name": "Aura Mastery",
        "shortName": "AM"
      },
      "fb58730d-151a-48b8-8100-f47b51e91fe5": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 186265,
        "icon_name": "ability_hunter_pet_turtle",
        "id": "fb58730d-151a-48b8-8100-f47b51e91fe5",
        "name": "Aspect of the Turtle",
        "shortName": "Turtle"
      },
      "fc7719be-9707-4b79-be11-e1e6580d046e": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 357170,
        "icon_name": "ability_evoker_timedilation",
        "id": "fc7719be-9707-4b79-be11-e1e6580d046e",
        "name": "Time Dilation",
        "shortName": "Dia"
      },
      "feb876f1-8dcd-4a92-9234-577aece679e0": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 51052,
        "icon_name": "spell_deathknight_antimagiczone",
        "id": "feb876f1-8dcd-4a92-9234-577aece679e0",
        "name": "Anti-Magic Zone",
        "shortName": "AMZ"
      }
    },
    "talentsById": {
      "00de5e1c-3258-4141-8c08-4b3726c263b2": {
        "game_id": 406732,
        "icon_name": "ability_evoker_stretchtime",
        "id": "00de5e1c-3258-4141-8c08-4b3726c263b2",
        "name": "Spatial Paradox",
        "shortName": "Para",
        "specId": "e6b1de69-ce2c-467c-ae7a-e1613ba23fb9"
      },
      "01e447b9-c926-41c4-b00e-69b13791feb2": {
        "game_id": 73325,
        "icon_name": "priest_spell_leapoffaith_a",
        "id": "01e447b9-c926-41c4-b00e-69b13791feb2",
        "link_suffix": "",
        "name": "Leap of Faith",
        "shortName": "Leap",
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690"
      },
      "028b6cfa-7232-41e9-828d-7e59eb5e53b9": {
        "game_id": 1044,
        "icon_name": "spell_holy_sealofvalor",
        "id": "028b6cfa-7232-41e9-828d-7e59eb5e53b9",
        "name": "Blessing of Freedom",
        "shortName": "Free",
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d"
      },
      "044e86a9-885e-4180-a808-bb649682236d": {
        "game_id": 266921,
        "icon_name": "ability_hunter_aspectoftheviper",
        "id": "044e86a9-885e-4180-a808-bb649682236d",
        "link_suffix": "?def=105648&rank=2",
        "name": "Born To Be Wild (2/2)",
        "shortName": "BtbW",
        "specId": "2fed59fd-6bdc-4b4e-a7d6-70c70cf8a5aa"
      },
      "09f94147-cd2c-4760-b6a6-c72119ad16ff": {
        "game_id": 370665,
        "icon_name": "ability_evoker_flywithme",
        "id": "09f94147-cd2c-4760-b6a6-c72119ad16ff",
        "link_suffix": "",
        "name": "Rescue",
        "shortName": "Resc",
        "specId": "cbfc9a1d-a504-4c56-8887-681e57a87211"
      },
      "0eafdd9a-7464-4923-8f2f-0ee4b9ab9a46": {
        "game_id": 116841,
        "icon_name": "ability_monk_tigerslust",
        "id": "0eafdd9a-7464-4923-8f2f-0ee4b9ab9a46",
        "name": "Tiger's Lust",
        "shortName": "Lust",
        "specId": "88f4a6b5-7766-41c3-b824-fbba531a2c8e"
      },
      "15632714-d0a2-4b64-91f8-0ebd519d44eb": {
        "game_id": 123040,
        "icon_name": "spell_shadow_soulleech_3",
        "id": "15632714-d0a2-4b64-91f8-0ebd519d44eb",
        "name": "Mindbender",
        "shortName": "Bender",
        "specId": "67a45712-192e-4916-ad57-d9a13124fea6"
      },
      "15d965d9-9925-4b64-ae46-a63d97c1f5ed": {
        "game_id": 108281,
        "icon_name": "ability_shaman_ancestralguidance",
        "id": "15d965d9-9925-4b64-ae46-a63d97c1f5ed",
        "name": "Ancestral Guidance",
        "shortName": "Guide",
        "specId": "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9"
      },
      "1982bd2c-d922-432a-842a-487e0232ec4a": {
        "game_id": 359816,
        "icon_name": "ability_evoker_dreamflight",
        "id": "1982bd2c-d922-432a-842a-487e0232ec4a",
        "name": "Dream Flight",
        "shortName": "Dream",
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873"
      },
      "1c63e505-ed5c-45f8-97d4-634580f32502": {
        "game_id": 10060,
        "icon_name": "spell_holy_powerinfusion",
        "id": "1c63e505-ed5c-45f8-97d4-634580f32502",
        "link_suffix": "",
        "name": "Power Infusion",
        "shortName": "PI",
        "specId": "67a45712-192e-4916-ad57-d9a13124fea6"
      },
      "239021f7-5a79-419c-8da7-292588e70edd": {
        "game_id": 199855,
        "icon_name": "achievement_boss_lanathel",
        "id": "239021f7-5a79-419c-8da7-292588e70edd",
        "name": "San'layn",
        "shortName": "San",
        "specId": "48c27d79-2cc2-4674-bfd0-9a471f6c7ced"
      },
      "28098ed2-33a2-4883-91e5-98e1ce3bed0d": {
        "game_id": 266921,
        "icon_name": "ability_hunter_aspectoftheviper",
        "id": "28098ed2-33a2-4883-91e5-98e1ce3bed0d",
        "link_suffix": "?def=105648&rank=1",
        "name": "Born To Be Wild (1/2)",
        "shortName": "BtbW",
        "specId": "2fed59fd-6bdc-4b4e-a7d6-70c70cf8a5aa"
      },
      "29bac947-b181-4ba8-9030-afb7044a0f31": {
        "game_id": 378425,
        "icon_name": "spell_holy_greaterblessingofsalvation",
        "id": "29bac947-b181-4ba8-9030-afb7044a0f31",
        "link_suffix": "?def=107474&rank=1",
        "name": "Uther's Counsel (1/2)",
        "shortName": "Counsel",
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d"
      },
      "2a833adb-fb0e-4b54-9f98-af7a6cfc0e83": {
        "game_id": 6262,
        "icon_name": "warlock_-healthstone",
        "id": "2a833adb-fb0e-4b54-9f98-af7a6cfc0e83",
        "name": "Healthstone",
        "shortName": "HS",
        "specId": "ab48ab5c-dfb9-4ce9-9557-8d0ce5129df2"
      },
      "2bc3e4f6-11a9-4225-bc58-98697672c128": {
        "game_id": 29166,
        "icon_name": "spell_nature_lightning",
        "id": "2bc3e4f6-11a9-4225-bc58-98697672c128",
        "link_suffix": "",
        "name": "Innervate",
        "shortName": "Inn",
        "specId": "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f"
      },
      "2f3db1c5-2619-41f2-84e1-c94a960532b8": {
        "game_id": 384820,
        "icon_name": "spell_holy_sealofsacrifice",
        "id": "2f3db1c5-2619-41f2-84e1-c94a960532b8",
        "name": "Sacrifice of the Just",
        "shortName": "Just",
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d"
      },
      "305ad67b-e950-4424-93fc-660b112f7b07": {
        "game_id": 390620,
        "icon_name": "ability_priest_savinggrace",
        "id": "305ad67b-e950-4424-93fc-660b112f7b07",
        "link_suffix": "",
        "name": "Move with Grace",
        "shortName": "Grace",
        "specId": "67a45712-192e-4916-ad57-d9a13124fea6"
      },
      "3523dbe5-540b-41dd-b1cd-7d65ca1401ea": {
        "game_id": 325197,
        "icon_name": "inv_pet_cranegod",
        "id": "3523dbe5-540b-41dd-b1cd-7d65ca1401ea",
        "name": "Invoke Chi-Ji, the Red Crane",
        "shortName": "Chi",
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3"
      },
      "360cde43-3b69-4401-8f26-68f5d56f4aeb": {
        "game_id": 73325,
        "icon_name": "priest_spell_leapoffaith_a",
        "id": "360cde43-3b69-4401-8f26-68f5d56f4aeb",
        "link_suffix": "",
        "name": "Leap of Faith",
        "shortName": "Leap",
        "specId": "48c27d79-2cc2-4674-bfd0-9a471f6c7ced"
      },
      "3b66a3e0-7960-40a3-9e5a-894951833520": {
        "game_id": 192077,
        "icon_name": "ability_shaman_windwalktotem",
        "id": "3b66a3e0-7960-40a3-9e5a-894951833520",
        "name": "Wind Rush Totem",
        "shortName": "WRT",
        "specId": "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9"
      },
      "3cc7d649-6033-4419-af00-b4c7451d08c9": {
        "game_id": 6940,
        "icon_name": "spell_holy_sealofsacrifice",
        "id": "3cc7d649-6033-4419-af00-b4c7451d08c9",
        "name": "Blessing of Sacrifice",
        "shortName": "Sac",
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d"
      },
      "407c87da-0b1a-4100-853d-7b7de8bc7387": {
        "game_id": 114052,
        "icon_name": "spell_fire_elementaldevastation",
        "id": "407c87da-0b1a-4100-853d-7b7de8bc7387",
        "name": "Ascendance",
        "shortName": "Asc",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "40eddbc9-887e-4be7-a8b9-e270403823ba": {
        "game_id": 266921,
        "icon_name": "ability_hunter_aspectoftheviper",
        "id": "40eddbc9-887e-4be7-a8b9-e270403823ba",
        "link_suffix": "?def=105648&rank=2",
        "name": "Born To Be Wild (2/2)",
        "shortName": "BtbW",
        "specId": "34b5a797-05ef-4431-91a0-64cc76a97624"
      },
      "44a0af8e-62d2-44b6-b9cf-b4ca047d62ca": {
        "game_id": 390620,
        "icon_name": "ability_priest_savinggrace",
        "id": "44a0af8e-62d2-44b6-b9cf-b4ca047d62ca",
        "link_suffix": "",
        "name": "Move with Grace",
        "shortName": "Grace",
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690"
      },
      "4938f839-6a91-462c-b992-b41e78881fe9": {
        "game_id": 374227,
        "icon_name": "ability_evoker_hoverblack",
        "id": "4938f839-6a91-462c-b992-b41e78881fe9",
        "name": "Zephyr",
        "shortName": "Zeph",
        "specId": "cbfc9a1d-a504-4c56-8887-681e57a87211"
      },
      "498f753d-cfbc-4d2c-ba71-823753945c2e": {
        "game_id": 33891,
        "icon_name": "ability_druid_improvedtreeform",
        "id": "498f753d-cfbc-4d2c-ba71-823753945c2e",
        "name": "Incarnation: Tree of Life",
        "shortName": "Tree",
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0"
      },
      "49cde047-4a88-4df9-80a1-4dc0c3953ac4": {
        "game_id": 1022,
        "icon_name": "spell_holy_sealofprotection",
        "id": "49cde047-4a88-4df9-80a1-4dc0c3953ac4",
        "name": "Blessing of Protection",
        "shortName": "BoP",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "4b5a6ee9-25c2-437f-a1b1-00da51e60c56": {
        "game_id": 393371,
        "icon_name": "ability_druid_treeoflife",
        "id": "4b5a6ee9-25c2-437f-a1b1-00da51e60c56",
        "name": "Cenarius' Guidance",
        "shortName": "Guide",
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0"
      },
      "4d6f3b2a-f84a-43f9-a018-8ec21fb84195": {
        "game_id": 266921,
        "icon_name": "ability_hunter_aspectoftheviper",
        "id": "4d6f3b2a-f84a-43f9-a018-8ec21fb84195",
        "link_suffix": "?def=105648&rank=2",
        "name": "Born To Be Wild (2/2)",
        "shortName": "BtbW",
        "specId": "0c9d68bc-e126-4a07-817a-72c37094e005"
      },
      "4dfbac2d-6f87-4391-85b0-5080346a095e": {
        "game_id": 10060,
        "icon_name": "spell_holy_powerinfusion",
        "id": "4dfbac2d-6f87-4391-85b0-5080346a095e",
        "link_suffix": "",
        "name": "Power Infusion",
        "shortName": "PI",
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690"
      },
      "4f7afe94-0e36-41d8-8560-236fa522beb5": {
        "game_id": 29166,
        "icon_name": "spell_nature_lightning",
        "id": "4f7afe94-0e36-41d8-8560-236fa522beb5",
        "link_suffix": "",
        "name": "Innervate",
        "shortName": "Inn",
        "specId": "6c233e8c-5bd4-4ece-9fb8-529a1e78759b"
      },
      "52016a77-9b0d-4b93-937f-18055955925a": {
        "game_id": 197073,
        "icon_name": "ability_druid_dreamstate",
        "id": "52016a77-9b0d-4b93-937f-18055955925a",
        "name": "Inner Peace",
        "shortName": "IP",
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0"
      },
      "57ef3256-3b78-4c7e-bc3e-8767a590f7dd": {
        "game_id": 207399,
        "icon_name": "spell_nature_reincarnation",
        "id": "57ef3256-3b78-4c7e-bc3e-8767a590f7dd",
        "name": "Ancestral Protection Totem",
        "shortName": "APT",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "594a40e8-bd2f-4358-8e40-d9daa5580c58": {
        "game_id": 124974,
        "icon_name": "achievement_zone_feralas",
        "id": "594a40e8-bd2f-4358-8e40-d9daa5580c58",
        "name": "Nature's Vigil",
        "shortName": "Vigil",
        "specId": "6c233e8c-5bd4-4ece-9fb8-529a1e78759b"
      },
      "5a32b827-1860-434c-915f-d470aac4b1c8": {
        "game_id": 389783,
        "icon_name": "sha_spell_warlock_demonsoul",
        "id": "5a32b827-1860-434c-915f-d470aac4b1c8",
        "name": "Pitch Black",
        "shortName": "Pitch",
        "specId": "08853913-0c47-4ca1-aec0-e93206a6ee45"
      },
      "5c63e9af-48bd-4a08-8738-c71c1a540bcc": {
        "game_id": 384820,
        "icon_name": "spell_holy_sealofsacrifice",
        "id": "5c63e9af-48bd-4a08-8738-c71c1a540bcc",
        "name": "Sacrifice of the Just",
        "shortName": "Just",
        "specId": "4ac0a1e4-3352-49e9-b455-faa83312526d"
      },
      "5d148a72-569a-4901-a4b1-6b5c05f71f17": {
        "game_id": 192077,
        "icon_name": "ability_shaman_windwalktotem",
        "id": "5d148a72-569a-4901-a4b1-6b5c05f71f17",
        "name": "Wind Rush Totem",
        "shortName": "WRT",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "66b049ed-1881-40bb-8279-69b611e0ac77": {
        "game_id": 391528,
        "icon_name": "ability_ardenweald_druid",
        "id": "66b049ed-1881-40bb-8279-69b611e0ac77",
        "name": "Convoke the Spirits",
        "shortName": "Con",
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0"
      },
      "71c5868a-def8-466a-b63d-fc82da933afd": {
        "game_id": 47788,
        "icon_name": "spell_holy_guardianspirit",
        "id": "71c5868a-def8-466a-b63d-fc82da933afd",
        "link_suffix": "",
        "name": "Guardian Spirit",
        "shortName": "GS",
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690"
      },
      "75ffa906-35ee-46fc-a1a3-846ee2e47899": {
        "game_id": 105809,
        "icon_name": "ability_paladin_holyavenger",
        "id": "75ffa906-35ee-46fc-a1a3-846ee2e47899",
        "name": "Holy Avenger",
        "shortName": "HA",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "7b15b336-3209-4055-893d-8ef670236bca": {
        "game_id": 108281,
        "icon_name": "ability_shaman_ancestralguidance",
        "id": "7b15b336-3209-4055-893d-8ef670236bca",
        "name": "Ancestral Guidance",
        "shortName": "Guide",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "7c3dbefe-6e19-495f-8e19-3913fd1bd2b7": {
        "game_id": 390620,
        "icon_name": "ability_priest_savinggrace",
        "id": "7c3dbefe-6e19-495f-8e19-3913fd1bd2b7",
        "link_suffix": "",
        "name": "Move with Grace",
        "shortName": "Grace",
        "specId": "48c27d79-2cc2-4674-bfd0-9a471f6c7ced"
      },
      "7c6fd8c0-30bb-4bc6-9d50-2b969b7571b4": {
        "game_id": 6940,
        "icon_name": "spell_holy_sealofsacrifice",
        "id": "7c6fd8c0-30bb-4bc6-9d50-2b969b7571b4",
        "name": "Blessing of Sacrifice",
        "shortName": "Sac",
        "specId": "4ac0a1e4-3352-49e9-b455-faa83312526d"
      },
      "7ced931c-d8d4-46bf-85cd-2bc713b2de65": {
        "game_id": 374968,
        "icon_name": "ability_evoker_timespiral",
        "id": "7ced931c-d8d4-46bf-85cd-2bc713b2de65",
        "name": "Time Spiral",
        "shortName": "Spiral",
        "specId": "e6b1de69-ce2c-467c-ae7a-e1613ba23fb9"
      },
      "7d749792-b86e-4a0c-b7af-a22c515c905d": {
        "game_id": 384820,
        "icon_name": "spell_holy_sealofsacrifice",
        "id": "7d749792-b86e-4a0c-b7af-a22c515c905d",
        "name": "Sacrifice of the Just",
        "shortName": "Just",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "800d564e-c86d-4bee-ab87-5a946fd60f77": {
        "game_id": 381922,
        "icon_name": "ability_evoker_rewind",
        "id": "800d564e-c86d-4bee-ab87-5a946fd60f77",
        "name": "Temporal Artificer",
        "shortName": "Temp. Art",
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873"
      },
      "80586d92-41db-40f1-ae5f-a978012ca6fd": {
        "game_id": 384909,
        "icon_name": "spell_holy_sealofprotection",
        "id": "80586d92-41db-40f1-ae5f-a978012ca6fd",
        "name": "Improved Blessing of Protection",
        "shortName": "Imp Blessing",
        "specId": "4ac0a1e4-3352-49e9-b455-faa83312526d"
      },
      "81601bb9-101e-454a-979e-a6ba776489ba": {
        "game_id": 116841,
        "icon_name": "ability_monk_tigerslust",
        "id": "81601bb9-101e-454a-979e-a6ba776489ba",
        "name": "Tiger's Lust",
        "shortName": "Lust",
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3"
      },
      "81b9786f-7c9a-4c30-b750-28f97721a7b7": {
        "game_id": 414660,
        "icon_name": "ability_racial_magicalresistance",
        "id": "81b9786f-7c9a-4c30-b750-28f97721a7b7",
        "name": "Mass Barrier",
        "shortName": "Barrier",
        "specId": "7f8d7fab-f5cc-4d47-9212-565bab25aeed"
      },
      "894e4c1a-ba49-4a3b-b269-8b3744ea8993": {
        "game_id": 288826,
        "icon_name": "spell_druid_stamedingroar",
        "id": "894e4c1a-ba49-4a3b-b269-8b3744ea8993",
        "name": "Improved Stampeding Roar",
        "shortName": "Imp. Roar",
        "specId": "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f"
      },
      "8e209307-a17b-46b0-910d-cc373e5f8ad5": {
        "game_id": 378425,
        "icon_name": "spell_holy_greaterblessingofsalvation",
        "id": "8e209307-a17b-46b0-910d-cc373e5f8ad5",
        "link_suffix": "?def=107474&rank=2",
        "name": "Uther's Counsel (2/2)",
        "shortName": "Counsel",
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d"
      },
      "8f71aa7f-af2a-4dd2-9f1f-3d54359c0f46": {
        "game_id": 421453,
        "icon_name": "ability_priest_ascendance",
        "id": "8f71aa7f-af2a-4dd2-9f1f-3d54359c0f46",
        "name": "Ultimate Penitence",
        "shortName": "Penti",
        "specId": "67a45712-192e-4916-ad57-d9a13124fea6"
      },
      "96558e37-14f0-443f-b8a1-14cb54899111": {
        "game_id": 414660,
        "icon_name": "ability_racial_magicalresistance",
        "id": "96558e37-14f0-443f-b8a1-14cb54899111",
        "name": "Mass Barrier",
        "shortName": "Barrier",
        "specId": "ab48ab5c-dfb9-4ce9-9557-8d0ce5129df2"
      },
      "97cbd734-cbb8-44ce-92f3-f24f57f9c278": {
        "game_id": 370665,
        "icon_name": "ability_evoker_flywithme",
        "id": "97cbd734-cbb8-44ce-92f3-f24f57f9c278",
        "link_suffix": "",
        "name": "Rescue",
        "shortName": "Resc",
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873"
      },
      "98617053-d678-46a5-aea8-6f8ad998a3d0": {
        "game_id": 399491,
        "icon_name": "inv_staff_2h_artifactshaohao_d_01",
        "id": "98617053-d678-46a5-aea8-6f8ad998a3d0",
        "link_suffix": "",
        "name": "Sheilun's Gift",
        "shortName": "Gift",
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3"
      },
      "986f8c08-5f23-48e4-9af0-f9e974cccb01": {
        "game_id": 32375,
        "icon_name": "spell_arcane_massdispel",
        "id": "986f8c08-5f23-48e4-9af0-f9e974cccb01",
        "link_suffix": "",
        "name": "Mass Dispel",
        "shortName": "Mass",
        "specId": "48c27d79-2cc2-4674-bfd0-9a471f6c7ced"
      },
      "98dc455b-cea8-4003-a669-68bf94dbd706": {
        "game_id": 114154,
        "icon_name": "spell_holy_holyguidance",
        "id": "98dc455b-cea8-4003-a669-68bf94dbd706",
        "name": "Unbreakable Spirit",
        "shortName": "Unbr",
        "specId": "4ac0a1e4-3352-49e9-b455-faa83312526d"
      },
      "9a5cd364-9619-40f6-b783-1d5135f4e7a3": {
        "game_id": 379391,
        "icon_name": "spell_holy_pureofheart",
        "id": "9a5cd364-9619-40f6-b783-1d5135f4e7a3",
        "name": "Quickened Invocation",
        "shortName": "Quickened Invocation",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "a47c5164-18f6-4906-aeb5-e71f041811e7": {
        "game_id": 265202,
        "icon_name": "ability_priest_archangel",
        "id": "a47c5164-18f6-4906-aeb5-e71f041811e7",
        "name": "Holy Word: Salvation",
        "shortName": "Salv",
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690"
      },
      "a4d2f672-c49e-4dfa-a83b-8bb53a8310b8": {
        "game_id": 376210,
        "icon_name": "ability_bossmagistrix_timewarp2",
        "id": "a4d2f672-c49e-4dfa-a83b-8bb53a8310b8",
        "name": "Erasure",
        "shortName": "Erasure",
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873"
      },
      "a6970508-b6df-4db0-8d96-453da1bbaf70": {
        "game_id": 29166,
        "icon_name": "spell_nature_lightning",
        "id": "a6970508-b6df-4db0-8d96-453da1bbaf70",
        "link_suffix": "",
        "name": "Innervate",
        "shortName": "Inn",
        "specId": "575905ae-cdc7-44c8-946c-861d50111b6d"
      },
      "a797ceed-5721-49ab-89cb-cd5ef27c393c": {
        "game_id": 374968,
        "icon_name": "ability_evoker_timespiral",
        "id": "a797ceed-5721-49ab-89cb-cd5ef27c393c",
        "name": "Time Spiral",
        "shortName": "Spiral",
        "specId": "cbfc9a1d-a504-4c56-8887-681e57a87211"
      },
      "a7d8a267-6a18-4292-88a3-e013c519229e": {
        "game_id": 202424,
        "icon_name": "ability_monk_domeofmist",
        "id": "a7d8a267-6a18-4292-88a3-e013c519229e",
        "name": "Chrysalis",
        "shortName": "Chrys",
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3"
      },
      "aa2917be-60cb-40a9-8bb7-c2eda9cada45": {
        "game_id": 216331,
        "icon_name": "ability_paladin_veneration",
        "id": "aa2917be-60cb-40a9-8bb7-c2eda9cada45",
        "name": "Avenging Crusader",
        "shortName": "Crusa",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "ab2034fc-2930-4d09-b300-b18938ad2e1e": {
        "game_id": 114154,
        "icon_name": "spell_holy_holyguidance",
        "id": "ab2034fc-2930-4d09-b300-b18938ad2e1e",
        "name": "Unbreakable Spirit",
        "shortName": "Unbr",
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d"
      },
      "abc55aba-b958-401e-9ea8-c46fcf6e7563": {
        "game_id": 373905,
        "icon_name": "ability_vehicle_shellshieldgenerator_green",
        "id": "abc55aba-b958-401e-9ea8-c46fcf6e7563",
        "name": "Personal 2min",
        "shortName": "Pers",
        "specId": "ab48ab5c-dfb9-4ce9-9557-8d0ce5129df2"
      },
      "abeb88c2-7c18-4580-8436-8cc6f0e45a12": {
        "game_id": 288826,
        "icon_name": "spell_druid_stamedingroar",
        "id": "abeb88c2-7c18-4580-8436-8cc6f0e45a12",
        "name": "Improved Stampeding Roar",
        "shortName": "Imp. Roar",
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0"
      },
      "aea41167-617a-4869-9209-57b95a9b7f96": {
        "game_id": 370665,
        "icon_name": "ability_evoker_flywithme",
        "id": "aea41167-617a-4869-9209-57b95a9b7f96",
        "link_suffix": "",
        "name": "Rescue",
        "shortName": "Resc",
        "specId": "e6b1de69-ce2c-467c-ae7a-e1613ba23fb9"
      },
      "aee09758-fd54-4baa-a99c-26e6bfc53275": {
        "game_id": 266921,
        "icon_name": "ability_hunter_aspectoftheviper",
        "id": "aee09758-fd54-4baa-a99c-26e6bfc53275",
        "link_suffix": "?def=105648&rank=1",
        "name": "Born To Be Wild (1/2)",
        "shortName": "BtbW",
        "specId": "0c9d68bc-e126-4a07-817a-72c37094e005"
      },
      "b04b16b4-c8ac-411e-bbd2-c7e97a1fc66a": {
        "game_id": 16191,
        "icon_name": "ability_shaman_manatidetotem",
        "id": "b04b16b4-c8ac-411e-bbd2-c7e97a1fc66a",
        "link_suffix": "",
        "name": "Mana Tide Totem",
        "shortName": "MTT",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "b07d824b-dae9-4128-aa17-960113a669d6": {
        "game_id": 392911,
        "icon_name": "spell_holy_fanaticism",
        "id": "b07d824b-dae9-4128-aa17-960113a669d6",
        "name": "Unwavering Spirit",
        "shortName": "Spirit",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "b3b02b26-5e57-4717-9170-2b20da209a25": {
        "game_id": 108281,
        "icon_name": "ability_shaman_ancestralguidance",
        "id": "b3b02b26-5e57-4717-9170-2b20da209a25",
        "name": "Ancestral Guidance",
        "shortName": "Guide",
        "specId": "1df0b300-a31e-4ebc-be57-a909f82bab4b"
      },
      "b5f1880d-fa01-4e01-abfa-90051be029d3": {
        "game_id": 192077,
        "icon_name": "ability_shaman_windwalktotem",
        "id": "b5f1880d-fa01-4e01-abfa-90051be029d3",
        "name": "Wind Rush Totem",
        "shortName": "WRT",
        "specId": "1df0b300-a31e-4ebc-be57-a909f82bab4b"
      },
      "b88a8d95-329b-4a47-9001-6a40c7ce44d9": {
        "game_id": 114154,
        "icon_name": "spell_holy_holyguidance",
        "id": "b88a8d95-329b-4a47-9001-6a40c7ce44d9",
        "name": "Unbreakable Spirit",
        "shortName": "Unbr",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "c0b9d905-4faf-449e-8cc5-62d5af706e83": {
        "game_id": 384909,
        "icon_name": "spell_holy_sealofprotection",
        "id": "c0b9d905-4faf-449e-8cc5-62d5af706e83",
        "name": "Improved Blessing of Protection",
        "shortName": "Imp Blessing",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "c42ffd64-26da-4beb-b288-dbe82933f3e9": {
        "game_id": 374968,
        "icon_name": "ability_evoker_timespiral",
        "id": "c42ffd64-26da-4beb-b288-dbe82933f3e9",
        "name": "Time Spiral",
        "shortName": "Spiral",
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873"
      },
      "c98871c3-83ea-4293-890f-6e143e2a2e87": {
        "game_id": 384909,
        "icon_name": "spell_holy_sealofprotection",
        "id": "c98871c3-83ea-4293-890f-6e143e2a2e87",
        "name": "Improved Blessing of Protection",
        "shortName": "Imp Blessing",
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d"
      },
      "cadc9039-5b5e-4f91-9abf-c76a7e631a73": {
        "game_id": 370511,
        "icon_name": "inv_potion_49",
        "id": "cadc9039-5b5e-4f91-9abf-c76a7e631a73",
        "name": "HP Pot",
        "shortName": "Pot",
        "specId": "ab48ab5c-dfb9-4ce9-9557-8d0ce5129df2"
      },
      "cbe1ec7e-0b9b-43a8-b935-37ca95037a28": {
        "game_id": 374227,
        "icon_name": "ability_evoker_hoverblack",
        "id": "cbe1ec7e-0b9b-43a8-b935-37ca95037a28",
        "name": "Zephyr",
        "shortName": "Zeph",
        "specId": "e6b1de69-ce2c-467c-ae7a-e1613ba23fb9"
      },
      "cf4c2e81-6529-4ddc-8067-81ea5160ebbe": {
        "game_id": 124974,
        "icon_name": "achievement_zone_feralas",
        "id": "cf4c2e81-6529-4ddc-8067-81ea5160ebbe",
        "name": "Nature's Vigil",
        "shortName": "Vigil",
        "specId": "575905ae-cdc7-44c8-946c-861d50111b6d"
      },
      "d1e6a9e3-a1ae-4ea1-b71e-c16d941a7750": {
        "game_id": 288826,
        "icon_name": "spell_druid_stamedingroar",
        "id": "d1e6a9e3-a1ae-4ea1-b71e-c16d941a7750",
        "name": "Improved Stampeding Roar",
        "shortName": "Imp. Roar",
        "specId": "6c233e8c-5bd4-4ece-9fb8-529a1e78759b"
      },
      "d2f7d123-426d-4d97-a25a-d8f7cc661a09": {
        "game_id": 382552,
        "icon_name": "spell_druid_ironbark",
        "id": "d2f7d123-426d-4d97-a25a-d8f7cc661a09",
        "name": "Improved Ironbark",
        "shortName": "Imp. IB",
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0"
      },
      "d339058d-622c-4a33-a19e-86f712f8b9ab": {
        "game_id": 389783,
        "icon_name": "sha_spell_warlock_demonsoul",
        "id": "d339058d-622c-4a33-a19e-86f712f8b9ab",
        "name": "Pitch Black",
        "shortName": "Pitch",
        "specId": "c95c2375-57fa-4ae8-9d55-c2e939b82247"
      },
      "d9c89245-c7cd-4c47-9453-0c3763b1e0f6": {
        "game_id": 288826,
        "icon_name": "spell_druid_stamedingroar",
        "id": "d9c89245-c7cd-4c47-9453-0c3763b1e0f6",
        "name": "Improved Stampeding Roar",
        "shortName": "Imp. Roar",
        "specId": "575905ae-cdc7-44c8-946c-861d50111b6d"
      },
      "db273c6f-f072-4542-9e40-ae7a5fc33544": {
        "game_id": 200209,
        "icon_name": "ability_priest_pathofthedevout",
        "id": "db273c6f-f072-4542-9e40-ae7a5fc33544",
        "link_suffix": "",
        "name": "Guardian Angel",
        "shortName": "GA",
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690"
      },
      "e2e5a6fa-907e-4b17-bc51-164330309e88": {
        "game_id": 266921,
        "icon_name": "ability_hunter_aspectoftheviper",
        "id": "e2e5a6fa-907e-4b17-bc51-164330309e88",
        "link_suffix": "?def=105648&rank=1",
        "name": "Born To Be Wild (1/2)",
        "shortName": "BtbW",
        "specId": "34b5a797-05ef-4431-91a0-64cc76a97624"
      },
      "e4be4ca1-4cb2-4325-aeff-955cca81cec3": {
        "game_id": 374227,
        "icon_name": "ability_evoker_hoverblack",
        "id": "e4be4ca1-4cb2-4325-aeff-955cca81cec3",
        "name": "Zephyr",
        "shortName": "Zeph",
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873"
      },
      "e5e78e16-a4aa-464d-88b2-e5579a580d85": {
        "game_id": 73325,
        "icon_name": "priest_spell_leapoffaith_a",
        "id": "e5e78e16-a4aa-464d-88b2-e5579a580d85",
        "link_suffix": "",
        "name": "Leap of Faith",
        "shortName": "Leap",
        "specId": "67a45712-192e-4916-ad57-d9a13124fea6"
      },
      "e8f11fe0-06b1-4369-9fed-f13344e8e213": {
        "game_id": 388212,
        "icon_name": "inv_pet_jadeserpentpet",
        "id": "e8f11fe0-06b1-4369-9fed-f13344e8e213",
        "name": "Gift of the Celestials",
        "shortName": "Gift",
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3"
      },
      "eabc5bf5-c27d-42d3-b6e0-8468e7c1a161": {
        "game_id": 200652,
        "icon_name": "inv_mace_2h_artifactsilverhand_d_01",
        "id": "eabc5bf5-c27d-42d3-b6e0-8468e7c1a161",
        "name": "Tyr's Deliverance",
        "shortName": "Tyr",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "eb13e796-1375-43cd-b198-1f1f55d6baef": {
        "game_id": 414660,
        "icon_name": "ability_racial_magicalresistance",
        "id": "eb13e796-1375-43cd-b198-1f1f55d6baef",
        "name": "Mass Barrier",
        "shortName": "Barrier",
        "specId": "a022f6ed-2b4e-4ddf-a7e9-7fb746f5adc2"
      },
      "eb1aebb0-bda2-40ae-9583-7880106bf32a": {
        "game_id": 370960,
        "icon_name": "ability_evoker_green_01",
        "id": "eb1aebb0-bda2-40ae-9583-7880106bf32a",
        "name": "Emerald Communion",
        "shortName": "Com",
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873"
      },
      "f5feefda-5464-4fa3-8970-51d652452328": {
        "game_id": 32375,
        "icon_name": "spell_arcane_massdispel",
        "id": "f5feefda-5464-4fa3-8970-51d652452328",
        "link_suffix": "",
        "name": "Mass Dispel",
        "shortName": "Mass",
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690"
      },
      "fa4bff3c-7b54-41dc-affb-a8a66f7a7283": {
        "game_id": 32375,
        "icon_name": "spell_arcane_massdispel",
        "id": "fa4bff3c-7b54-41dc-affb-a8a66f7a7283",
        "link_suffix": "",
        "name": "Mass Dispel",
        "shortName": "Mass",
        "specId": "67a45712-192e-4916-ad57-d9a13124fea6"
      },
      "fd48549c-adae-4459-aa15-fa3d529f34df": {
        "game_id": 375576,
        "icon_name": "ability_bastion_paladin",
        "id": "fd48549c-adae-4459-aa15-fa3d529f34df",
        "name": "Divine Toll",
        "shortName": "Toll",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      }
    }
  }`)
